import React, { useEffect, useState, useCallback, useRef } from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { useMemo } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from "react-redux"
import * as AuthActions from "../../../store/actions/auth";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import MenuBook from '@material-ui/icons/MenuBook';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { styled } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import Searchbar from './patientSearchBar';
import ExerciseLibrary from '../exerciseLibraryFolder/exerciseLibrary';
import SelectedPatientExercises from '../singlePatientOverviewFolder/selectedPatientProgramBuilder';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from '@material-ui/icons/Remove';
import Star from '@material-ui/icons/Star';
import SelectedPatientProgram from '../singlePatientOverviewFolder/selectedPatientProgram';
import PatientTable from './PatientTable';
import axios from 'axios';
import DiscreteSliderAdmin from "../../user_dashboard/treatmentSession/rehabPhaseProgressBar_admin";
import DiscreteSliderDevelopment from '../../user_dashboard/treatmentSession/SymptomDevelopmentFeedback';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import CreatePatientDialog from './CreatePatientDialog';
import DiagnosisCell from './DiagnosisCell';
import AddTreatmentDialog from './AddTreatmentDialog';
import { useGenerateAssessmentLink } from '../../../utilities/useGenerateAssessmentLink';
import { apiBaseUrl } from '../../../utilities/configureApiFetch';

const PATIENT_ROSTER_CACHE_TTL_MS = 60 * 1000;
const patientRosterCache = new Map();

const getCachedPatientRoster = (token) => {
  const cached = patientRosterCache.get(token);
  if (!cached || Date.now() - cached.fetchedAt >= PATIENT_ROSTER_CACHE_TTL_MS) {
    return null;
  }
  return cached.profiles;
};

const StyledTableRow = styled(TableRow)({
  '& td, & th': {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
  },'&:hover': {
    background: '#FFF',
  },
  '&.selected': {
    background: '#FFF',
  }
});


const GetJournalButton = withStyles({
    root: {
      boxShadow: "none",
      textTransform: "none",
      fontSize: 15,
      padding: "4px 8px",
      marginRight: 3,
      border: "0.5px solid",
      lineHeight: 0,
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "#002D55",
      "&:hover": {
          //boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
          backgroundColor: "white",
          borderColor: "#FF7F27"
      },
      "&:active": {
        //boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
        backgroundColor: "#FFFFFF",
        borderColor: "#FF7F27"
      },
      //"&:focus": {
      //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
      //}
    }
  })(IconButton);

const CreateButton = withStyles((theme) => ({
  root: {
    boxShadow: 'none',
    padding: 6,
    minHeight: 40,
    height: 40,
    minWidth: 40,
    width: 40,
    margin: '4px 6px 0 0',
    borderRadius: 8,
    backgroundColor: 'transparent',
    border: '1px solid transparent',
    color: '#002D55',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    '& svg': {
      fontSize: 20,
      display: 'block'
    },
    '&:hover': {
      backgroundColor: '#fff',
      borderColor: '#FF7F27'
    },
    '&:focus': {
      outline: `2px solid rgba(255,165,0,0.15)`,
    },
  }
}))(IconButton);
  //logout
    //
    //


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    paddingTop: 2,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
    marginBottom: '0.6%',
    background: '#f7faff',
    borderRadius: 14,
    overflow: 'hidden',
  },
  container: {
    marginBottom: "0.6%",
    padding: 0,
  },
  hover: {
    "&:hover": {
      backgroundColor: "lightgray",
    },
  },
  selected: {
    backgroundColor: "lightgray",
  },
  container2: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    background: 'transparent',
  },
  orangeFocused: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#002D55', // brandcolor blue
    },
    '& .MuiInputLabel-outlined': {
      color: '#002D55', // brandcolor blue (default, not focused)
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27', // hover effect
    },
  },
  responsiveText: {
    fontSize: 'clamp(0.66rem, calc(0.291rem + 0.549vw), 0.95rem)'
  },
  responsiveText2: {
    fontSize: 'clamp(0.52rem, calc(0.231rem + 0.433vw), 0.75rem)'
  },
  hideOnXs: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  wideTooltip: {
    // allow wide tooltips (used for multi-column hover details)
    maxWidth: 'none',
    whiteSpace: 'normal',
    padding: 8,
  },
  TableRow: {
  '& td, & th': {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 'clamp(2px, calc(-1px + 0.7vw), 8px)',
    paddingRight: 'clamp(2px, calc(-1px + 0.7vw), 8px)',
  }
}
}));

// Helper: format numbers to one decimal. If isPercent is true, append "%".
const fmt1 = (v, isPercent = false) => {
  if (v === null || v === undefined) return '-';
  const n = Number(v);
  if (Number.isNaN(n)) return '-';
  const rounded = Math.round(n * 10) / 10;
  return isPercent ? `${rounded}%` : `${rounded}`;
};

// Decide color for a change value. For pain/freq: decrease = good (green), little change = yellow, increase = bad (red).
// For function set invert=true to reverse (increase = good).
const trendColor = (change, isPercent = false, invert = false) => {
  if (change === null || change === undefined) return '#002D55';
  const n = Number(change);
  if (Number.isNaN(n)) return '#002D55';
  const abs = Math.abs(n);
  // thresholds: percent changes use 2 (% points), absolute numeric use 1 point
  const threshold = isPercent ? 2 : 1;
  if (abs <= threshold) return '#fbc02d'; // yellow (little/no change)
  const increased = n > 0; // positive means increase
  const isGood = invert ? increased : !increased;
  return isGood ? '#66bb6a' : '#f14747ff';
};

const getDiagnosisForTreatment = (patient, treatmentId) => {
  const diagnoses = Array.isArray(patient?.diagnosis) ? patient.diagnosis : [];
  return diagnoses.find((diagnosis) => (
    String(diagnosis?.treatment_id || diagnosis?.id || '') === String(treatmentId || '')
  )) || diagnoses[diagnoses.length - 1] || null;
};

// Component: show a spinner for up to 3 seconds, then show 'n/a' if no value.
// (TimedProgress and persistence moved inside the PatientList component)



export default function PatientList(props) {
  // Read auth directly from Redux so component updates when a different user logs in
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const token = useSelector(state => state.auth.token);
  const backendBaseUrl = apiBaseUrl;
  const { generateAssessmentLink } = useGenerateAssessmentLink(backendBaseUrl, token);
  const [isLoading, setIsLoading] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [diagnosis, setDiagnosis] = useState([])

  const [exercises, setExercises] = useState([])
  // Shared exercise library (fetch once and pass down)
  const [libraryExercises, setLibraryExercises] = useState([]);
  const [libraryLoaded, setLibraryLoaded] = useState(false);
  // Store all phases for the selected patient
  const [patientPhases, setPatientPhases] = useState([])
  const [current_exercise_ind, setCurrent_exercise_ind] = useState(0)
  const [phases, setPhases] = useState([]);
  const [profiles, setProfiles] = useState(() => getCachedPatientRoster(token) || [])
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedPhaseId, setSelectedPhaseId] = useState('');
  // Per-patient selected treatment mapping: { [userId]: treatmentId }
  const [selectedTreatmentByUser, setSelectedTreatmentByUser] = useState({});
  // Back-compat for any places still expecting a single selected diagnosis id
  const [selectedDiagnosisId, setSelectedDiagnosisId] = useState(null);
  const selectedPatientRef = useRef(null);
  const selectedTreatmentByUserRef = useRef({});
  const fetchUserTableDataRef = useRef(null);
  const metricsRequestKeyRef = useRef({});

  useEffect(() => {
    selectedPatientRef.current = selectedPatient;
  }, [selectedPatient]);

  useEffect(() => {
    selectedTreatmentByUserRef.current = selectedTreatmentByUser;
  }, [selectedTreatmentByUser]);

  // Derive treatments array for DiagnosisCell from existing diagnosis data on profile
  const deriveTreatmentsFromProfile = useCallback((profile) => {
    if (!profile || !Array.isArray(profile.diagnosis)) return [];
    const patientId = profile.user_id || profile.id || 'patient';
    return profile.diagnosis.map((diag, idx) => ({
      // Prefer explicit backend-provided treatment_id; fallback to synthesized id
      id: diag.treatment_id || `${patientId}-treat-${idx}`,
      treatment_id: diag.treatment_id || null,
      diagnosis_id: diag.diagnosis_id || diag.id || null, // UUID
      diagnosis_identifier: diag.diagnosis_identifier || diag.identifier || null, // string identifier used by APIs
      name: diag.treatment_name || null, // Treatment name from backend
      primary_complaint_key: diag.primary_complaint_key || '',
      primary_complaint_label: diag.primary_complaint_label || '',
      exercise_library_region: diag.exercise_library_region || '',
      diagnosis: { diagnosis: diag.title || diag.identifier || diag.diagnosis || 'Unknown Diagnosis' }
    }));
  }, []);

  // Component: show a spinner for up to 3 seconds, then show 'n/a' if no value.
  const TimedProgress = ({ hasValue, valueNode = null, watchKey = '', size = 18, className = '' }) => {
    const [timedOut, setTimedOut] = useState(false);
    useEffect(() => {
      setTimedOut(false);
      const t = setTimeout(() => setTimedOut(true), 1000);
      return () => clearTimeout(t);
    }, [watchKey]);

    if (hasValue) return valueNode || null;
    if (!timedOut) return <CircularProgress size={size} className={className} />;
    return <span className={className} style={{ color: '#666' }}>-</span>;
  };

  

  // ✅ Phase 1: Consolidated patient data fetching from parent
  const [selectedPatientData, setSelectedPatientData] = useState(null); // { assessmentDate, phases, advices, diagnosis, allDiagnoses, session }
  const [selectedPatientDataLoading, setSelectedPatientDataLoading] = useState(false);
  const abortControllerRef = useRef(null);
  const lastFetchParamsRef = useRef(null); // Track last fetch to avoid duplicates

  // Add: per-patient metrics cache + fetch helpers
const [patientMetrics, setPatientMetrics] = useState({}); // { [userId]: { baseline, improvements, fetchedAt } }
const [loadingMetrics, setLoadingMetrics] = useState({}); // { [userId]: boolean }
  // current logged in user info (for scoping persisted keys)
  const user = useSelector(state => state.auth && state.auth.user);
  const userId = user && (user.id || user.user_id) ? (user.id || user.user_id) : null;
  //const prevUserIdRef = useRef(undefined);

  // Persist patientMetrics per-user to localStorage and restore when userId changes
  useEffect(() => {
    if (!userId) return;
    const key = `vp_patientMetrics_${userId}`;
    try {
      const raw = localStorage.getItem(key);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') setPatientMetrics(parsed);
      }
    } catch (e) {
      // ignore
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(() => {
    if (!userId) return;
    const key = `vp_patientMetrics_${userId}`;
    try {
      localStorage.setItem(key, JSON.stringify(patientMetrics || {}));
      // Also persist a compact score summary (compliance, pain, function, nps) per user
      try {
        const deriveScores = (metrics) => {
          if (!metrics) return null;
          const imp = metrics.improvements || metrics.improvements_payload || {};
          const base = metrics.baseline || metrics.baseline_payload || {};
          // compliance
          const compliance = imp && imp.compliance && (imp.compliance.avgCompliance !== undefined) ? imp.compliance.avgCompliance : null;
          // function
          let func = null;
          const funcImp = (imp && Array.isArray(imp.comparisons)) ? imp.comparisons.find(c => { const id=(c.question_identifier||'').toLowerCase(); if (id.includes('_atbest')||id.includes('_atworst')) return false; if (id.includes('selfratedfunction')||id.includes('function')) return true; if (id.includes('psfs')&&(id.includes('function')||id.includes('goal')||id.includes('main'))) return true; return false; }) : null;
          if (funcImp && funcImp.followup_value !== undefined && funcImp.followup_value !== null) func = funcImp.followup_value;
          else if (base && base.baselines) {
            const bf = extractFunctionFromBaseline(base);
            if (bf && bf.numeric_value !== undefined && bf.numeric_value !== null) func = bf.numeric_value;
          }
          // nps
          let nps = null;
          const npsImp = (imp && Array.isArray(imp.comparisons)) ? imp.comparisons.find(c => { const id=(c.question_identifier||'').toLowerCase(); return id.includes('nps')||id.includes('selfrated_nps')||id.includes('selfratednps')||id.includes('netpromoter'); }) : null;
          if (npsImp && npsImp.followup_value !== undefined && npsImp.followup_value !== null) nps = npsImp.followup_value;
          else {
            const nb = extractNPSFromBaseline(base);
            if (nb && nb.numeric_value !== undefined && nb.numeric_value !== null) nps = nb.numeric_value;
          }
          // pain
          let pain = null;
          const comps = (imp && Array.isArray(imp.comparisons)) ? imp.comparisons : [];
          const compCurrent = comps.find(c => { const id=(c.question_identifier||'').toLowerCase(); if (id.includes('_atbest')||id.includes('_atworst')) return false; return id.includes('current')||id.includes('selfratedpain')||id.includes('pain'); }) || null;
          if (compCurrent && compCurrent.followup_value !== undefined && compCurrent.followup_value !== null) pain = compCurrent.followup_value;
          else if (compCurrent && compCurrent.baseline_value !== undefined && compCurrent.baseline_value !== null) pain = compCurrent.baseline_value;
          else {
            const pf = extractPainFromBaseline(base);
            if (pf !== undefined && pf !== null) pain = pf;
          }
          return { compliance, pain, function: func, nps, fetchedAt: metrics.fetchedAt || null };
        };
        const compact = {};
        Object.keys(patientMetrics || {}).forEach(k => { compact[k] = deriveScores(patientMetrics[k]); });
        localStorage.setItem(`vp_patientScores_${userId}`, JSON.stringify(compact));
      } catch (err2) {
        // ignore
      }
    } catch (e) {
      // ignore
    }
  }, [patientMetrics, userId]);

/** Fetch baseline + improvements for a specific patient (uses path-style endpoints added in backend) */
const fetchPatientMetrics = async (userId, diagnosisIdentifier, treatmentId, options = {}) => {
  if (!userId || !diagnosisIdentifier) return null;
  const { force = false } = options || {};
  // Cache key includes treatment_id to isolate metrics per treatment
  const cacheKey = `${userId}_${treatmentId || diagnosisIdentifier}`;
  const cached = patientMetrics[cacheKey];
  if (!force && cached && (Date.now() - (cached.fetchedAt || 0) < 1000 * 60 * 5)) return cached;
  if (loadingMetrics[cacheKey]) return null;
  setLoadingMetrics(prev => ({ ...prev, [cacheKey]: true }));
  try {
    const headers = { 'Authorization': `Token ${token}`, 'Accept': 'application/json' };
    const baseUrl = backendBaseUrl;
    const diag = encodeURIComponent(diagnosisIdentifier);
    const treatmentParam = treatmentId ? `?treatment_id=${treatmentId}` : '';

    // Fetch baseline + improvements (server-side improvements endpoint will prefer stored DB value and only compute as fallback)
    const [baseRes, impRes, kpiRes] = await Promise.all([
      fetch(`${baseUrl}/question-handler/baseline/${diag}/${userId}/?qtypes=selfRatedPain,selfRatedFunction${treatmentId ? `&treatment_id=${treatmentId}` : ''}`, { headers }),
      fetch(`${baseUrl}/question-handler/improvements/${diag}/${userId}/${treatmentParam}`, { headers }),
      treatmentId ? fetch(`${baseUrl}/treatment/treatments/${treatmentId}/kpi_items/`, { headers }) : Promise.resolve(null)
    ]);

    const baseline = baseRes && baseRes.ok ? await baseRes.json() : null;
    const improvements = impRes && impRes.ok ? await impRes.json() : null;
    const kpiJson = kpiRes && kpiRes.ok ? await kpiRes.json() : null;
    const kpiItems = (kpiJson && Array.isArray(kpiJson.kpi_items)) ? kpiJson.kpi_items : [];

    const payload = { baseline, improvements, kpiItems, fetchedAt: Date.now() };
    setPatientMetrics(prev => ({ ...prev, [cacheKey]: payload }));
    return payload;
  } catch (err) {
    console.error('fetchPatientMetrics', err);
    return null;
  } finally {
    setLoadingMetrics(prev => ({ ...prev, [cacheKey]: false }));
  }
};

const hasPatientMetricData = (metrics) => {
  if (!metrics) return false;
  if (Array.isArray(metrics.kpiItems) && metrics.kpiItems.length > 0) return true;
  if (Array.isArray(metrics.improvements && metrics.improvements.comparisons) && metrics.improvements.comparisons.length > 0) return true;

  const baselines = metrics.baseline && metrics.baseline.baselines;
  return Boolean(baselines && Object.values(baselines).some(section => (
    Array.isArray(section && section.items) && section.items.length > 0
  )));
};

/** helpers to extract function info from payloads */
const extractFunctionFromImprovements = (improvements) => {
  if (!improvements || !Array.isArray(improvements.comparisons)) return null;
  const comp = improvements.comparisons.find(c => {
    const id = (c.question_identifier || '').toLowerCase();
    return id.includes('selfratedfunction') || id.includes('psfs') || id.includes('function');
  });
  if (!comp) return null;
  return {
    baseline_text: comp.baseline_text || null,
    followup_value: (comp.followup_value !== undefined ? comp.followup_value : null),
    percent_change: (comp.percent_change !== undefined ? comp.percent_change : null),
    absolute_change: (comp.absolute_change !== undefined ? comp.absolute_change : null)
  };
};

const extractFunctionFromBaseline = (baselinePayload) => {
  if (!baselinePayload || !baselinePayload.baselines) return null;
  const func = baselinePayload.baselines.selfRatedFunction;
  if (!func || !Array.isArray(func.items) || func.items.length === 0) return null;
  const it = func.items[0];
  return {
    baseline_text: it.text_value || null,
    numeric_value: (it.numeric_value !== undefined ? it.numeric_value : (it.answerId ? parseInt(it.answerId, 10) || null : null))
  };
};

// Extract NPS information from improvements payload. Matches identifiers like 'nps', 'selfrated_nps', 'selfratednps'
const extractNPSFromImprovements = (improvements) => {
  if (!improvements || !Array.isArray(improvements.comparisons)) return null;
  const comp = improvements.comparisons.find(c => {
    const id = (c.question_identifier || '').toLowerCase();
    return id.includes('nps') || id.includes('selfrated_nps') || id.includes('selfratednps') || id.includes('netpromoter');
  });
  if (!comp) return null;
  return {
    baseline_value: (comp.baseline_value !== undefined ? comp.baseline_value : null),
    followup_value: (comp.followup_value !== undefined ? comp.followup_value : null),
    percent_change: (comp.percent_change !== undefined ? comp.percent_change : null),
    absolute_change: (comp.absolute_change !== undefined ? comp.absolute_change : null),
    baseline_text: comp.baseline_text || null,
    followup_text: comp.followup_text || null
  };
};

// Extract NPS from baseline payload. Prefer entries under selfRatedFunction/selfRated_NPS; otherwise scan baseline sections for numeric values in 0-10 range.
const extractNPSFromBaseline = (baselinePayload) => {
  if (!baselinePayload || !baselinePayload.baselines) return null;
  // First try the selfRatedFunction section (NPS may be stored here after mapping)
  const srFunc = baselinePayload.baselines.selfRatedFunction;
  if (srFunc && Array.isArray(srFunc.items) && srFunc.items.length) {
    const it = srFunc.items[0];
    // If the numeric value looks like an NPS (0-10) use it
    const maybe = (it.numeric_value !== undefined && it.numeric_value !== null) ? Number(it.numeric_value) : (it.answerId ? parseInt(it.answerId, 10) : null);
    if (maybe !== null && !Number.isNaN(maybe) && maybe >= 0 && maybe <= 10) {
      return { numeric_value: maybe, baseline_text: it.text_value || null };
    }
  }
  // Otherwise scan all baseline sections for a numeric value that looks like an NPS (0-10)
  const keys = Object.keys(baselinePayload.baselines || {});
  for (const k of keys) {
    const b = baselinePayload.baselines[k];
    if (b && Array.isArray(b.items) && b.items.length) {
      const it = b.items[0];
      const val = (it.numeric_value !== undefined && it.numeric_value !== null) ? Number(it.numeric_value) : (it.answerId ? parseInt(it.answerId, 10) : null);
      if (val !== null && !Number.isNaN(val) && val >= 0 && val <= 10) {
        return { numeric_value: val, baseline_text: it.text_value || null };
      }
    }
  }
  return null;
};

// Extract a numeric pain baseline value from baseline payloads.
// Returns a number (0-100 scale expected) or null when not found.
const extractPainFromBaseline = (baselinePayload) => {
  if (!baselinePayload || !baselinePayload.baselines) return null;
  // Prefer explicit selfRatedPain baseline if present
  const pain = baselinePayload.baselines.selfRatedPain;
  if (pain && Array.isArray(pain.items) && pain.items.length) {
    const it = pain.items[0];
    if (it && it.numeric_value !== undefined && it.numeric_value !== null) return it.numeric_value;
    if (it && it.answerId) return parseInt(it.answerId, 10) || null;
  }
  // Fallback: search any baseline section for a numeric value
  const keys = Object.keys(baselinePayload.baselines || {});
  for (const k of keys) {
    const b = baselinePayload.baselines[k];
    if (b && Array.isArray(b.items) && b.items.length) {
      const it = b.items[0];
      if (it && it.numeric_value !== undefined && it.numeric_value !== null) return it.numeric_value;
      if (it && it.answerId) return parseInt(it.answerId, 10) || null;
    }
  }
  return null;
};

// When 'profiles' changes (initial load), only merge cached metrics (do NOT fetch improvements eagerly).
useEffect(() => {
  if (!profiles || !Array.isArray(profiles)) return;
  profiles.forEach((p) => {
    const uid = p.user_id || p.id || (p.user && p.user.id);
    if (!uid) return;

    // Determine treatment_id for this profile to build correct cache key
    const profileTreatmentId = selectedTreatmentByUser[uid] || 
      (p.diagnosis && p.diagnosis.length ? (p.diagnosis[p.diagnosis.length - 1].treatment_id || p.diagnosis[p.diagnosis.length - 1].id) : null);
    const diagId = getDiagnosisForTreatment(p, profileTreatmentId)?.diagnosis_identifier
      || getDiagnosisForTreatment(p, profileTreatmentId)?.identifier
      || p.diagnosisIdentifier
      || null;
    const cacheKey = `${uid}_${profileTreatmentId || diagId}`;
    
    // Clear legacy metrics that lack a cache key (pre-treatment isolation)
    if (p._metrics && !p._metrics._cacheKey) {
      console.log('[profiles effect] Clearing legacy metrics without cache key for user', uid, 'new key:', cacheKey);
      setProfiles(prev => prev.map(r => ( (r.user_id || r.id || (r.user && r.user.id)) === uid ? { ...r, _metrics: undefined } : r )));
      return; // Will re-run and merge correct cached metrics on next iteration
    }

    // If we have metrics but they're for the WRONG treatment, clear them
    if (p._metrics && p._metrics._cacheKey && p._metrics._cacheKey !== cacheKey) {
      console.log('[profiles effect] Clearing stale metrics for user', uid, 'old key:', p._metrics._cacheKey, 'new key:', cacheKey);
      setProfiles(prev => prev.map(r => ( (r.user_id || r.id || (r.user && r.user.id)) === uid ? { ...r, _metrics: undefined } : r )));
      return; // Will re-run and merge correct cached metrics on next iteration
    }
    
    // Check if we already have the correct metrics for this treatment
    if (p._metrics && p._metrics._cacheKey === cacheKey) return; // already merged with correct treatment
    
    // If we have cached metrics in patientMetrics (possibly restored from localStorage), merge them.
    // Only merge if the cached data is fresh (< 5 min) to avoid showing stale pre-repair data.
    const METRICS_TTL_MS = 5 * 60 * 1000;
    const cached = patientMetrics[cacheKey];
    const isCachedFresh = cached && (Date.now() - (cached.fetchedAt || 0) < METRICS_TTL_MS);
    if (isCachedFresh) {
      const funcImp = extractFunctionFromImprovements(cached.improvements);
      const funcBase = extractFunctionFromBaseline(cached.baseline);
      const merged = {
        baseline_text: (funcImp && funcImp.baseline_text) || (funcBase && funcBase.baseline_text) || null,
        latest_function: (funcImp && funcImp.followup_value !== null && funcImp.followup_value !== undefined) ? funcImp.followup_value : (funcBase && funcBase.numeric_value !== null ? funcBase.numeric_value : null),
        function_percent: funcImp && funcImp.percent_change !== null && funcImp.percent_change !== undefined ? funcImp.percent_change : null,
        baseline_payload: cached.baseline,
        improvements_payload: cached.improvements,
        kpi_items: cached.kpiItems || [],
        fetchedAt: cached.fetchedAt || null,
        _cacheKey: cacheKey // Track which treatment these metrics belong to
      };
      // console.log('[profiles effect] Merging fresh cached metrics for user', uid, 'key:', cacheKey);
      setProfiles(prev => prev.map(r => ( (r.user_id || r.id || (r.user && r.user.id)) === uid ? { ...r, _metrics: merged } : r )));
    }
    // Do NOT fetch metrics for every profile on initial load — lazy-load on user click instead.
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [profiles, patientMetrics, selectedTreatmentByUser]);

// Lazy-load metrics for a single profile when the user selects/clicks that patient.
  const prefetchExercisesForPhases = useCallback(async (patientUserId, treatmentId, phasesData) => {
    if (!patientUserId || !treatmentId || !Array.isArray(phasesData) || phasesData.length === 0) return;

    const currentPatient = selectedPatientRef.current;
    if (
      String(currentPatient?.user_id || '') !== String(patientUserId) ||
      String(currentPatient?.treatment_id || '') !== String(treatmentId)
    ) return;

    const activeDiagnosis = getDiagnosisForTreatment(currentPatient, treatmentId);
    let phase = null;
    if (activeDiagnosis?.name) {
      phase = phasesData.find((item) => (
        item.name && item.name.toLowerCase().startsWith(activeDiagnosis.name.toLowerCase())
      ));
    }
    if (!phase && typeof activeDiagnosis?.index === 'number') {
      phase = phasesData.find((item, index) => (
        index === activeDiagnosis.index || item.index === activeDiagnosis.index
      ));
    }
    if (!phase && (activeDiagnosis?.phase_id || activeDiagnosis?.current_phase_id)) {
      const activePhaseId = activeDiagnosis.phase_id || activeDiagnosis.current_phase_id;
      phase = phasesData.find((item) => String(item.id) === String(activePhaseId));
    }
    phase = phase || phasesData[0];
    if (!phase?.id) return;

    const requestKey = `${patientUserId}:${treatmentId}:${phase.id}`;
    const cached = exerciseCacheRef.current.get(requestKey);
    if (cached && Date.now() - cached.fetchedAt < 5 * 60 * 1000) {
      setExercises(cached.exercises);
      return cached.exercises;
    }
    const existingRequest = exerciseFetchRef.current.inFlight.get(requestKey);
    if (existingRequest) return existingRequest;

    const requestId = exerciseFetchRef.current.requestId + 1;
    exerciseFetchRef.current.requestId = requestId;
    const request = fetch(
      `${backendBaseUrl}/treatment/exercises/phase/${phase.id}/${patientUserId}/?treatment_id=${encodeURIComponent(treatmentId)}`,
      { headers: { 'Authorization': `Token ${token}`, Accept: 'application/json' } }
    )
      .then((response) => response.ok ? response.json() : Promise.reject('Failed to fetch phase exercises'))
      .then((data) => {
        const nextExercises = data.exercises || [];
        exerciseCacheRef.current.set(requestKey, { exercises: nextExercises, fetchedAt: Date.now() });
        const selected = selectedPatientRef.current;
        if (
          exerciseFetchRef.current.requestId === requestId &&
          String(selected?.user_id || '') === String(patientUserId) &&
          String(selected?.treatment_id || '') === String(treatmentId)
        ) {
          setExercises(nextExercises);
        }
        return nextExercises;
      })
      .finally(() => {
        exerciseFetchRef.current.inFlight.delete(requestKey);
      });
    exerciseFetchRef.current.inFlight.set(requestKey, request);
    return request;
  }, [token]);

  // ✅ Phase 1: Master fetch function - consolidated all patient data into single request
  const fetchPatientAllData = useCallback(async (patientUserId, diagnosisId = null, treatmentId = null) => {
    if (!patientUserId) return;
    // Do not call protected endpoints without a valid token
    if (!token || (typeof token === 'string' && token.trim() === '')) {
      setSelectedPatientDataLoading(false);
      return;
    }
    
    // Avoid duplicate fetches with same params (debounce rapid calls from multiple effects)
    const fetchKey = `${patientUserId}-${diagnosisId || 'null'}-${treatmentId || 'null'}`;
    if (lastFetchParamsRef.current === fetchKey) {
      console.log('[fetchPatientAllData] Skipping duplicate fetch', fetchKey);
      return;
    }
    lastFetchParamsRef.current = fetchKey;
    
    // Cancel any in-flight requests
    if (abortControllerRef.current) {
      try { abortControllerRef.current.abort(); } catch (e) {}
    }
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    
    setSelectedPatientDataLoading(true);
    try {
      const headers = {
        'Authorization': `Token ${token}`,
        'Accept': 'application/json',
      };
      
      // Fetch ALL data in parallel (NOT sequential)
      // Prefer treatmentId (most precise); fall back only to the provided diagnosisId (avoid stale global selection)
      const effectiveTreatmentId = treatmentId || (selectedTreatmentByUser[patientUserId] || null);
      const effectiveDiagId = diagnosisId || null;
      const queryStr = effectiveTreatmentId
        ? `?treatment_id=${encodeURIComponent(effectiveTreatmentId)}`
        : (effectiveDiagId ? `?diagnosis_id=${encodeURIComponent(effectiveDiagId)}` : '');
      const phaseDataPromise = fetch(`${backendBaseUrl}/treatment/phases/patient/${patientUserId}/${queryStr}`,
        { headers, signal, method: 'GET' })
        .then(async (response) => {
          if (!response.ok) return null;
          const phaseData = await response.json();
          if (!signal.aborted) {
            setSelectedPatientData((previousData) => ({
              ...(previousData || {}),
              phases: phaseData,
              _patientUserId: patientUserId,
              _treatmentId: effectiveTreatmentId || null,
            }));
            prefetchExercisesForPhases(patientUserId, effectiveTreatmentId, phaseData).catch(() => {});
          }
          return phaseData;
        })
        .catch(() => null);
      const responses = await Promise.all([
        fetch(`${backendBaseUrl}/treatment/answered_assessment_date/${patientUserId}/${queryStr}`,
          { headers, signal, method: 'GET' }).catch(e => null),
        phaseDataPromise,
        fetch(`${backendBaseUrl}/treatment/advices/patient/${patientUserId}/${queryStr}`,
          { headers, signal, method: 'GET' }).catch(e => null),
        // Fetch diagnosis if we have either diagnosisId OR treatmentId
        (effectiveDiagId || effectiveTreatmentId) ? fetch(`${backendBaseUrl}/treatment/diagnoses/${effectiveDiagId || effectiveTreatmentId}/?user_id=${patientUserId}`,
          { headers, signal, method: 'GET' }).catch(e => null) : Promise.resolve(null),
        fetch(`${backendBaseUrl}/treatment/all_diagnosis/${patientUserId}/`,
          { headers, signal, method: 'GET' }).catch(e => null),
        fetch(`${backendBaseUrl}/treatment/session/active/${patientUserId}/${queryStr}`,
          { headers, signal, method: 'GET' }).catch(e => null)
      ]);
      
      if (signal.aborted) return;
      
      // Parse all responses
      const data = {};
      if (responses[0]?.ok) data.assessmentDate = await responses[0].json();
      if (responses[1]) {
        data.phases = responses[1];
        // console.log('[fetchPatientAllData] Phases response:', {
        //   treatment_id: data.phases?.treatment_id,
        //   phases: data.phases?.phases?.map(p => ({id: p.id, name: p.name})) || []
        // });
      }
      if (responses[2]?.ok) data.advices = await responses[2].json();
      
      // Parse allDiagnoses first to resolve diagnosis by treatment_id if needed
      if (responses[4]?.ok) data.allDiagnoses = await responses[4].json();
      
      // If diagnosis fetch succeeded, use it; otherwise resolve from allDiagnoses
      if (responses[3]?.ok) {
        data.diagnosis = await responses[3].json();
      } else if (effectiveTreatmentId && data.allDiagnoses) {
        // Resolve diagnosis from allDiagnoses using treatment_id
        const match = Array.isArray(data.allDiagnoses) 
          ? data.allDiagnoses.find(d => (d.treatment_id || d.id) === effectiveTreatmentId)
          : null;
        if (match) {
          data.diagnosis = match;
          // console.log('[fetchPatientAllData] Resolved diagnosis from allDiagnoses:', match);
        }
      }
      
      if (responses[5]?.ok) data.session = await responses[5].json();
      
      if (!signal.aborted) {
        // Tag the payload with the patient id it belongs to, to avoid using stale data after a fast patient switch
        // console.log('[fetchPatientAllData] Setting selectedPatientData with:', {
        //   patientUserId,
        //   hasAdvices: !!data.advices,
        //   advicesCount: Array.isArray(data.advices) ? data.advices.length : (data.advices?.count || 0),
        //   hasDiagnosis: !!data.diagnosis,
        //   diagnosisTitle: data.diagnosis?.title,
        //   diagnosisTreatmentId: data.diagnosis?.treatment_id,
        //   hasPhases: !!data.phases,
        //   phasesCount: data.phases?.phases?.length || 0
        // });
        setSelectedPatientData({ ...data, _patientUserId: patientUserId, _treatmentId: effectiveTreatmentId || null });
      }
    } catch (e) {
      if (e.name !== 'AbortError') {
        console.error('Error fetching patient data:', e);
      }
    } finally {
      if (!signal.aborted) {
        setSelectedPatientDataLoading(false);
      }
    }
  }, [token, selectedTreatmentByUser, prefetchExercisesForPhases]);

  // Trigger fetch when selectedPatient changes. Guard against stale diagnosis/treatment leakage.
  useEffect(() => {
    if (!selectedPatient?.user_id) return;

    const uid = selectedPatient.user_id || selectedPatient.id || (selectedPatient.user && selectedPatient.user.id);
    if (!uid) return;

    const hasTreatments = Array.isArray(selectedPatient.treatments) && selectedPatient.treatments.length > 0;
    // If treatments exist but treatment_id not yet set, wait for auto-select effect to set it
    if (hasTreatments && !selectedPatient.treatment_id) return;

    // Resolve treatment and diagnosis
    const treatmentId = selectedPatient.treatment_id || selectedTreatmentByUser[uid] || null;
    let diagUuid = selectedPatient.selected_diagnosis_id || null;
    let diagIdentifier = selectedPatient.selected_diagnosis_identifier || null;

    if (!diagUuid && treatmentId && hasTreatments) {
      const match = selectedPatient.treatments.find(t => (t.id || t.treatment_id) === treatmentId);
      diagUuid = match?.diagnosis_id || null;
      if (!diagIdentifier) {
        diagIdentifier = match?.diagnosis_identifier || match?.identifier || null;
      }
    }

    if (!diagUuid) {
      const latestDiag = getDiagnosisForTreatment(selectedPatient, treatmentId);
      diagUuid = latestDiag?.diagnosis_id || latestDiag?.id || null;
      if (!diagIdentifier) {
        diagIdentifier = latestDiag?.identifier || null;
      }
    }

    // console.log('[PatientList] selectedPatient effect resolved', {
    //   uid,
    //   treatmentId,
    //   diagUuid,
    //   diagIdentifier,
    //   treatments: selectedPatient.treatments,
    //   selectedPatient
    // });

    // Keep global selectedDiagnosisId in sync for downstream consumers (identifier for UI)
    setSelectedDiagnosisId(diagIdentifier || null);

    // Fetch all scoped data with resolved treatment/diagnosis (UUID for backend)
    fetchPatientAllData(uid, diagUuid, treatmentId);

    return () => {
      if (abortControllerRef.current) {
        try { abortControllerRef.current.abort(); } catch (e) {}
      }
    };
  }, [selectedPatient?.user_id, selectedPatient?.treatment_id, selectedPatient?.selected_diagnosis_id, selectedPatient?.selected_diagnosis_identifier, fetchPatientAllData]);

const runWithJournalEditingGuard = useCallback((label, action) => {
  if (typeof action !== 'function') return;
  if (typeof window !== 'undefined') {
    const guard = window.__vpJournalUnsavedGuard;
    const isEditingMode = guard && typeof guard.isEditingMode === 'function'
      ? guard.isEditingMode()
      : false;
    if (isEditingMode && typeof guard.request === 'function') {
      guard.request(label, action);
      return;
    }
  }
  action();
}, []);

const handleSelectProfile = useCallback(async (profile) => {
  runWithJournalEditingGuard(profile ? 'switching patients' : 'clearing the selected patient', async () => {
    setSearchInput('');
    if (!profile) { setSelectedPatient(null); return; }
    
    const uid = profile.user_id || profile.id || (profile.user && profile.user.id);
    
    // CRITICAL: If user already chose a treatment via dropdown, preserve it (don't override with latest)
    const userChosenTreatmentId = selectedTreatmentByUser[uid];
    
    let initialTreatmentId, initialDiagId, initialDiagIdentifier;
    
    if (userChosenTreatmentId) {
      // User already selected a treatment - find it in the profile's diagnoses
      const chosenDiag = profile.diagnosis?.find(d => (d.treatment_id || d.id) === userChosenTreatmentId);
      if (chosenDiag) {
        initialTreatmentId = chosenDiag.treatment_id || chosenDiag.id || null;
        initialDiagId = chosenDiag.diagnosis_id || chosenDiag.id || null;
        initialDiagIdentifier = chosenDiag.diagnosis_identifier || chosenDiag.identifier || null;
        console.log('[handleSelectProfile] Preserving user-chosen treatment', { uid, userChosenTreatmentId, chosenDiag });
      } else {
        // Fallback to latest if chosen treatment not found
        const latestDiag = (profile.diagnosis && profile.diagnosis.length)
          ? profile.diagnosis[profile.diagnosis.length - 1]
          : null;
        initialTreatmentId = latestDiag ? (latestDiag.treatment_id || latestDiag.id || null) : null;
        initialDiagId = latestDiag ? (latestDiag.diagnosis_id || latestDiag.id || null) : null;
        initialDiagIdentifier = latestDiag ? (latestDiag.diagnosis_identifier || latestDiag.identifier || null) : null;
      }
    } else {
      // No user selection yet - use latest diagnosis from profile
      const latestDiag = (profile.diagnosis && profile.diagnosis.length)
        ? profile.diagnosis[profile.diagnosis.length - 1]
        : null;
      initialTreatmentId = latestDiag ? (latestDiag.treatment_id || latestDiag.id || null) : null;
      initialDiagId = latestDiag ? (latestDiag.diagnosis_id || latestDiag.id || null) : null;
      initialDiagIdentifier = latestDiag ? (latestDiag.diagnosis_identifier || latestDiag.identifier || null) : null;
    }

    // console.log('[handleSelectProfile] Resolved treatment IDs', {
    //   uid,
    //   initialTreatmentId,
    //   initialDiagId,
    //   initialDiagIdentifier,
    //   profileDiagnosis: profile.diagnosis
    // });

    setSelectedPatient({ 
      ...profile, 
      treatment_id: initialTreatmentId, 
      selected_diagnosis_id: initialDiagId,
      selected_diagnosis_identifier: initialDiagIdentifier,
      treatment: { ...(profile.treatment || {}), id: initialTreatmentId }
    });
    setSelectedDiagnosisId(initialDiagIdentifier || null);
    
    // CRITICAL: Clear stale data from previous patient to prevent phase/exercise guard from blocking updates
    setSelectedPatientData(null);
    setSelectedPhaseId(''); // Clear phase selection for new patient
    userSelectedPhaseRef.current = false; // Reset user intent for new patient
    
    if (!uid) return;
    const diagId = initialDiagIdentifier || profile.diagnosisIdentifier || null;
    if (!diagId) return;

    // Use treatment-specific cache key
    const cacheKey = `${uid}_${initialTreatmentId || diagId}`;
    const cached = patientMetrics[cacheKey];
    const isCachedFresh = cached && (Date.now() - (cached.fetchedAt || 0) < 5 * 60 * 1000);
    if (isCachedFresh) {
      const funcImp = extractFunctionFromImprovements(cached.improvements);
      const funcBase = extractFunctionFromBaseline(cached.baseline);
      const merged = {
        baseline_text: (funcImp && funcImp.baseline_text) || (funcBase && funcBase.baseline_text) || null,
        latest_function: (funcImp && funcImp.followup_value !== null && funcImp.followup_value !== undefined) ? funcImp.followup_value : (funcBase && funcBase.numeric_value !== null ? funcBase.numeric_value : null),
        function_percent: funcImp && funcImp.percent_change !== null && funcImp.percent_change !== undefined ? funcImp.percent_change : null,
        baseline_payload: cached.baseline,
        improvements_payload: cached.improvements,
        kpi_items: cached.kpiItems || [],
        fetchedAt: cached.fetchedAt || null,
        _cacheKey: cacheKey
      };
      setProfiles(prev => prev.map(r => ( (r.user_id || r.id || (r.user && r.user.id)) === uid ? { ...r, _metrics: merged } : r )));
      // Also update selectedPatient with merged metrics for immediate display
      setSelectedPatient(prev => ({ ...prev, _metrics: merged }));
      return;
    }

    // Lazy-load metrics for the clicked patient only, passing treatment_id for isolation
    metricsRequestKeyRef.current[uid] = cacheKey;
    const metrics = await fetchPatientMetrics(uid, diagId, initialTreatmentId);
    if (!metrics) return;
    if (metricsRequestKeyRef.current[uid] !== cacheKey) return;
    const funcImp = extractFunctionFromImprovements(metrics.improvements);
    const funcBase = extractFunctionFromBaseline(metrics.baseline);
    const merged = {
      baseline_text: (funcImp && funcImp.baseline_text) || (funcBase && funcBase.baseline_text) || null,
      latest_function: (funcImp && funcImp.followup_value !== null && funcImp.followup_value !== undefined) ? funcImp.followup_value : (funcBase && funcBase.numeric_value !== null ? funcBase.numeric_value : null),
      function_percent: funcImp && funcImp.percent_change !== null && funcImp.percent_change !== undefined ? funcImp.percent_change : null,
      baseline_payload: metrics.baseline,
      improvements_payload: metrics.improvements,
      kpi_items: metrics.kpiItems || [],
      fetchedAt: metrics.fetchedAt || null,
      _cacheKey: cacheKey
    };
    setProfiles(prev => prev.map(r => ( (r.user_id || r.id || (r.user && r.user.id)) === uid ? { ...r, _metrics: merged } : r )));
    // Also update selectedPatient with merged metrics for immediate display on initial selection
    setSelectedPatient(prev => {
      const selectedUid = prev && (prev.user_id || prev.id || (prev.user && prev.user.id));
      const selectedKey = `${selectedUid}_${prev && (prev.treatment_id || diagId)}`;
      if (selectedKey !== cacheKey) return prev;
      return { ...prev, _metrics: hasPatientMetricData(metrics) ? merged : null };
    });
  });
}, [patientMetrics, fetchPatientMetrics, selectedTreatmentByUser, runWithJournalEditingGuard]);

  // When a treatment is selected from DiagnosisCell, re-run the existing selection logic
  const handleTreatmentSelect = useCallback((treatment, profile) => {
    if (!profile) return;
    const uid = profile.user_id || profile.id || (profile.user && profile.user.id);
    const selectedUid = selectedPatient?.user_id || selectedPatient?.id || (selectedPatient?.user && selectedPatient.user.id);
    const guardLabel = selectedUid && uid && String(selectedUid) !== String(uid)
      ? 'switching patients'
      : 'switching treatments';

    runWithJournalEditingGuard(guardLabel, () => {
      if (treatment && treatment.id && uid) {
        const chosenTid = treatment.treatment_id || treatment.id;
        const chosenDiagIdentifier = treatment.diagnosis_identifier || treatment.identifier || (treatment.diagnosis && treatment.diagnosis.identifier) || null;
        const chosenDiagUuid = treatment.diagnosis_id || (treatment.diagnosis && (treatment.diagnosis.diagnosis_id || treatment.diagnosis.id)) || null;
        // Fallback: resolve diagnosis info from profile when treatment object lacks identifiers
        const matchDiag = (!chosenDiagIdentifier || !chosenDiagUuid) && Array.isArray(profile.diagnosis)
          ? profile.diagnosis.find(d => (d.treatment_id || d.id) === chosenTid)
          : null;
        const resolvedDiagIdentifier = chosenDiagIdentifier || (matchDiag && (matchDiag.diagnosis_identifier || matchDiag.identifier)) || null;
        const resolvedDiagUuid = chosenDiagUuid || (matchDiag && (matchDiag.diagnosis_id || matchDiag.id)) || null;
        
        console.log('[PatientList] handleTreatmentSelect - USER ACTION', {
          uid,
          chosenTid,
          chosenDiagUuid: resolvedDiagUuid,
          chosenDiagIdentifier: resolvedDiagIdentifier,
          treatment
        });
        
        // CRITICAL: Clear selectedPhaseId FIRST to prevent 403 errors
        setSelectedPhaseId('');
        // CRITICAL: Clear old phases/exercises and cached data to prevent stale validation
        setPatientPhases([]);
        setExercises([]);
        setSelectedPatientData(null);
        patientPhasesTreatmentRef.current = null; // Clear phase ownership tracking
        
        // CRITICAL: Clear fetch deduplication to force new data fetch
        lastFetchParamsRef.current = null;
        
        // CRITICAL: Update selectedTreatmentByUser FIRST so sync effect sees it
        setSelectedTreatmentByUser(prev => ({ ...prev, [uid]: chosenTid }));
        setSelectedDiagnosisId(resolvedDiagIdentifier || null);
        const newCacheKey = `${uid}_${chosenTid}`;
        metricsRequestKeyRef.current[uid] = newCacheKey;
        
        // CRITICAL: Clear old metrics from profile to force refetch for new treatment
        setProfiles(prev => prev.map(r => {
          const rowUid = r.user_id || r.id || (r.user && r.user.id);
          return rowUid === uid ? { ...r, _metrics: undefined } : r;
        }));
        // Also clear selectedPatient metrics to avoid showing stale data during refetch
        setSelectedPatient(prev => ({ ...prev, _metrics: undefined }));
        
        // Update selectedPatient with chosen treatment IMMEDIATELY
        setSelectedPatient(prev => {
          const next = { 
            ...(prev && ( (prev.user_id || prev.id || (prev.user && prev.user.id)) === uid ) ? prev : profile),
            treatment_id: chosenTid, 
            selected_diagnosis_id: resolvedDiagUuid,
            selected_diagnosis_identifier: resolvedDiagIdentifier || null,
            treatment: { ...((prev && ( (prev.user_id || prev.id || (prev.user && prev.user.id)) === uid ) ? prev.treatment : profile.treatment) || {}), id: chosenTid }
          };
          console.log('[PatientList] handleTreatmentSelect - updated selectedPatient', next);
          return next;
        });
        
        // Fetch metrics for new treatment (async, will update profiles when done)
        if (resolvedDiagIdentifier) {
          fetchPatientMetrics(uid, resolvedDiagIdentifier, chosenTid).then(metrics => {
            if (!metrics) return;
            if (metricsRequestKeyRef.current[uid] !== newCacheKey) return;
            const funcImp = extractFunctionFromImprovements(metrics.improvements);
            const funcBase = extractFunctionFromBaseline(metrics.baseline);
            const merged = {
              baseline_text: (funcImp && funcImp.baseline_text) || (funcBase && funcBase.baseline_text) || null,
              latest_function: (funcImp && funcImp.followup_value !== null && funcImp.followup_value !== undefined) ? funcImp.followup_value : (funcBase && funcBase.numeric_value !== null ? funcBase.numeric_value : null),
              function_percent: funcImp && funcImp.percent_change !== null && funcImp.percent_change !== undefined ? funcImp.percent_change : null,
              baseline_payload: metrics.baseline,
              improvements_payload: metrics.improvements,
              kpi_items: metrics.kpiItems || [],
              fetchedAt: metrics.fetchedAt || null,
              _cacheKey: newCacheKey
            };
            setProfiles(prev => prev.map(r => ( (r.user_id || r.id || (r.user && r.user.id)) === uid ? { ...r, _metrics: merged } : r )));
            // Also update selectedPatient with new treatment's metrics for immediate display
            setSelectedPatient(prev => {
              const selectedUid = prev && (prev.user_id || prev.id || (prev.user && prev.user.id));
              if (String(selectedUid) !== String(uid) || String(prev && prev.treatment_id) !== String(chosenTid)) return prev;
              return { ...prev, _metrics: hasPatientMetricData(metrics) ? merged : null };
            });
          });
        }
        
        // Fetch consolidated data scoped by this treatment id
        // Let the effect (line 626) handle the fetch when selectedPatient.treatment_id changes
      }
    });
  }, [fetchPatientMetrics, extractFunctionFromImprovements, extractFunctionFromBaseline, runWithJournalEditingGuard, selectedPatient?.user_id, selectedPatient?.id, selectedPatient?.user, selectedPatient]);

  // In patientList.js: modify the auto-select effect

useEffect(() => {
  if (!selectedPatient) return;
  
  const uid = selectedPatient.user_id || selectedPatient.id || (selectedPatient.user && selectedPatient.user.id);
  if (!uid) return;
  
  const availableTreatments = selectedPatient.treatments || [];
  if (availableTreatments.length === 0) return;
  
  // ✅ If user already chose a treatment OR patient already has treatment_id set, preserve it
  if (selectedTreatmentByUser[uid] || selectedPatient.treatment_id) return;
  
  // ✅ Only auto-select if exactly 1 treatment exists
  if (availableTreatments.length !== 1) return;
  
  // Single treatment: auto-select it
  const onlyTreatment = availableTreatments[0];
  const treatmentId = onlyTreatment.treatment_id || onlyTreatment.id;
  const diagnosisId = onlyTreatment.diagnosis_id || (onlyTreatment.diagnosis && (onlyTreatment.diagnosis.diagnosis_id || onlyTreatment.diagnosis.id)) || null;
  const diagnosisIdentifier = onlyTreatment.diagnosis_identifier || onlyTreatment.identifier || (onlyTreatment.diagnosis && onlyTreatment.diagnosis.identifier) || null;
  
  setSelectedPatient(prev => {
    if (!prev || prev.treatment_id === treatmentId) return prev;
    const prevUid = prev.user_id || prev.id || (prev.user && prev.user.id);
    if (prevUid !== uid) return prev;
    return {
      ...prev,
      treatment_id: treatmentId,
      selected_diagnosis_id: diagnosisId,
      selected_diagnosis_identifier: diagnosisIdentifier || null,
      treatment: { ...(prev.treatment || {}), id: treatmentId }
    };
  });
  
  setSelectedTreatmentByUser(prev => ({ ...prev, [uid]: treatmentId }));
  setSelectedDiagnosisId(diagnosisIdentifier || null);
}, [selectedPatient?.user_id, selectedPatient?.treatment_id, selectedTreatmentByUser]);

  // ✅ Sync `selectedPatient` with the user's explicit dropdown choice (debounced to avoid fighting handleTreatmentSelect)
  useEffect(() => {
    if (!selectedPatient) return;
    const uid = selectedPatient.user_id || selectedPatient.id || (selectedPatient.user && selectedPatient.user.id);
    if (!uid) return;
    const chosenTid = selectedTreatmentByUser[uid];
    if (!chosenTid) return;
    
    // If already aligned, skip (handleTreatmentSelect already updated it)
    if (selectedPatient.treatment_id === chosenTid) return;
    
    // Debounce to let handleTreatmentSelect complete first
    const timer = setTimeout(() => {
      const availableTreatments = selectedPatient.treatments || [];
      const chosen = availableTreatments.find(t => ((t.treatment_id || t.id) === chosenTid));
      if (!chosen) return;
      const treatmentId = chosen.treatment_id || chosen.id;
      const diagnosisUuid = chosen.diagnosis_id || (chosen.diagnosis && (chosen.diagnosis.diagnosis_id || chosen.diagnosis.id)) || null;
      const diagnosisIdentifier = chosen.diagnosis_identifier || chosen.identifier || (chosen.diagnosis && chosen.diagnosis.identifier) || null;
      
      console.log('[PatientList] Sync effect aligning treatment (debounced)', { uid, chosenTid, treatmentId, diagnosisUuid, diagnosisIdentifier });
      
      setSelectedPatient(prev => {
        if (!prev) return prev;
        const prevUid = prev.user_id || prev.id || (prev.user && prev.user.id);
        if (prevUid !== uid) return prev;
        // Double-check still misaligned before updating
        if (prev.treatment_id === chosenTid) return prev;
        return {
          ...prev,
          treatment_id: treatmentId,
          selected_diagnosis_id: diagnosisUuid,
          selected_diagnosis_identifier: diagnosisIdentifier || null,
          treatment: { ...(prev.treatment || {}), id: treatmentId }
        };
      });
      setSelectedDiagnosisId(diagnosisIdentifier || null);
    }, 50); // 50ms debounce
    
    return () => clearTimeout(timer);
  }, [selectedTreatmentByUser, selectedPatient?.treatment_id, fetchPatientAllData]);
  
  // Clear selectedPhaseId when treatment changes to prevent fetching with stale phase
  const lastTreatmentIdRef = useRef(null);
  useEffect(() => {
    const currentTreatmentId = selectedPatient?.treatment_id || null;
    // If treatment changed, clear the phase selection AND phases/exercises data
    if (lastTreatmentIdRef.current !== null && lastTreatmentIdRef.current !== currentTreatmentId) {
      console.log('[PatientList] Treatment changed from', lastTreatmentIdRef.current, 'to', currentTreatmentId, '- clearing phase, phases, and exercises');
      setSelectedPhaseId('');
      setPatientPhases([]); // Clear old phases to prevent stale validation
      setExercises([]); // Clear old exercises
      userSelectedPhaseRef.current = false; // Reset user intent for new treatment
    }
    lastTreatmentIdRef.current = currentTreatmentId;
  }, [selectedPatient?.treatment_id]);
  
  // Safe setter: only update if different. Mark as user-selected when called externally.
  const safeSetSelectedPhaseId = useCallback((newId, isUserAction = false) => {
    setSelectedPhaseId(prev => {
      if (prev !== newId) {
        if (isUserAction) {
          userSelectedPhaseRef.current = true;
        }
        return newId;
      }
      return prev;
    });
  }, []);
  
  // Wrapper for child component: mark all phase changes from child as user actions
  const handleChildSetSelectedPhaseId = useCallback((newPhaseId, isUserAction = true) => {
    safeSetSelectedPhaseId(newPhaseId, isUserAction);
  }, [safeSetSelectedPhaseId]);
  
  // Track previous selectedPatient user_id
  const prevUserIdRef = useRef(null);
  // Track previous treatment_id to detect treatment changes
  const prevTreatmentIdRef = useRef(null);
  // Guard: only restore saved patient once per user
  const restoredPatientRef = useRef(false);
  // Track which treatment_id the current patientPhases belong to
  const patientPhasesTreatmentRef = useRef(null);
  // Track user intent: when user manually selects phase, don't auto-reset
  const userSelectedPhaseRef = useRef(false);
  const exerciseFetchRef = useRef({ requestId: 0, inFlight: new Map() });
  const exerciseCacheRef = useRef(new Map());
  const patientPhaseIdsKey = patientPhases.map(phase => String(phase.id)).sort().join('|');

  // Combined effect: use consolidated phases data to set selectedPhaseId
  useEffect(() => {
    if (!selectedPatient || !selectedPatient.user_id) {
      setPatientPhases([]);
      setSelectedPhaseId('');
      prevUserIdRef.current = null;
      prevTreatmentIdRef.current = null;
      userSelectedPhaseRef.current = false;
      return;
    }
    // If the fetched data belongs to a different patient (stale), clear phases until the correct payload arrives
    if (selectedPatientData?._patientUserId && selectedPatientData._patientUserId !== selectedPatient.user_id) {
      setPatientPhases([]);
      setSelectedPhaseId('');
      return;
    }
    const currentTreatmentId = selectedPatient.treatment_id || null;
    // If the fetched data belongs to a different treatment, clear phases until correct payload arrives
    if (selectedPatientData?._treatmentId && selectedPatientData._treatmentId !== currentTreatmentId) {
      setPatientPhases([]);
      setSelectedPhaseId('');
      patientPhasesTreatmentRef.current = null;
      return;
    }
    // Use phases from selectedPatientData (already fetched by fetchPatientAllData)
    const phasesData = selectedPatientData?.phases?.phases || [];
    setPatientPhases(phasesData);
    // Track which treatment these phases belong to
    patientPhasesTreatmentRef.current = phasesData.length > 0 ? currentTreatmentId : null;
    
    if (!phasesData || phasesData.length === 0) {
      setSelectedPhaseId('');
      return;
    }
    
    const userIdChanged = prevUserIdRef.current !== null && prevUserIdRef.current !== selectedPatient.user_id;
    const treatmentChanged = prevTreatmentIdRef.current !== null && prevTreatmentIdRef.current !== currentTreatmentId;
    
    // Only auto-select phase when patient or treatment actually changes (not on data refresh)
    // AND user hasn't manually selected a phase
    if ((userIdChanged || treatmentChanged) && !userSelectedPhaseRef.current) {
      // console.log('[PatientList] User or treatment changed - auto-selecting phase. User changed:', userIdChanged, 'Treatment changed:', treatmentChanged);
      let currentPhaseName = '';
      let currentPhaseIndex = undefined;
      if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
        const activeDiagnosis = getDiagnosisForTreatment(selectedPatient, currentTreatmentId);
        if (activeDiagnosis && activeDiagnosis.name) {
          currentPhaseName = activeDiagnosis.name;
        }
        if (typeof activeDiagnosis?.index === 'number') {
          currentPhaseIndex = activeDiagnosis.index;
        }
      }
      let match = null;
      if (currentPhaseName) {
        match = phasesData.find(phase =>
          phase.name && phase.name.toLowerCase().startsWith(currentPhaseName.toLowerCase())
        );
      }
      if (!match && typeof currentPhaseIndex === 'number') {
        match = phasesData.find((phase, idx) => idx === currentPhaseIndex || phase.index === currentPhaseIndex);
      }
      if (match) {
        // console.log('[PatientList] Auto-selecting phase by match:', match.name, match.id);
        setSelectedPhaseId(match.id);
      } else {
        // Fallback: select first phase
        console.log('[PatientList] No match found, selecting first phase:', phasesData[0].name, phasesData[0].id);
        setSelectedPhaseId(phasesData[0].id);
      }
      prevUserIdRef.current = selectedPatient.user_id;
      prevTreatmentIdRef.current = currentTreatmentId;
      // Reset user intent flag when auto-selecting for new patient/treatment
      userSelectedPhaseRef.current = false;
      return;
    }
    
    // Update tracking refs even if we didn't auto-select (for next time)
    if (userIdChanged || treatmentChanged) {
      prevUserIdRef.current = selectedPatient.user_id;
      prevTreatmentIdRef.current = currentTreatmentId;
    }
    
    // Only auto-select if phase is not set AND user hasn't manually selected
    if (!selectedPhaseId && !userSelectedPhaseRef.current) {
      let currentPhaseName = '';
      let currentPhaseIndex = undefined;
      if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
        const activeDiagnosis = getDiagnosisForTreatment(selectedPatient, currentTreatmentId);
        if (activeDiagnosis && activeDiagnosis.name) {
          currentPhaseName = activeDiagnosis.name;
        }
        if (typeof activeDiagnosis?.index === 'number') {
          currentPhaseIndex = activeDiagnosis.index;
        }
      }
      let match = null;
      if (currentPhaseName) {
        match = phasesData.find(phase =>
          phase.name && phase.name.toLowerCase().startsWith(currentPhaseName.toLowerCase())
        );
      }
      if (!match && typeof currentPhaseIndex === 'number') {
        match = phasesData.find((phase, idx) => idx === currentPhaseIndex || phase.index === currentPhaseIndex);
      }
      if (match) {
        setSelectedPhaseId(match.id);
      } else {
        let currentPhaseId = '';
        if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
          const activeDiagnosis = getDiagnosisForTreatment(selectedPatient, currentTreatmentId);
          if (activeDiagnosis && activeDiagnosis.phase_id) {
            currentPhaseId = activeDiagnosis.phase_id;
          } else if (activeDiagnosis && activeDiagnosis.current_phase_id) {
            currentPhaseId = activeDiagnosis.current_phase_id;
          }
        }
        if (currentPhaseId) {
          setSelectedPhaseId(currentPhaseId);
        }
      }
    }
  }, [selectedPatient?.user_id, selectedPatient?.treatment_id, selectedPhaseId, selectedPatientData?.phases]);

  // 3. When selectedPhaseId or treatment_id changes, fetch exercises for that phase
  useEffect(() => {
    // console.log('[DEBUG] selectedPhaseId or treatment changed:', selectedPhaseId, selectedPatient?.treatment_id);
    
    // Don't fetch if we just cleared the phase (empty string)
    if (!selectedPhaseId) {
      // console.log('[DEBUG] selectedPhaseId is empty, skipping fetch');
      return;
    }
    
    const currentTreatmentId = selectedPatient?.treatment_id;
    
    // CRITICAL: Only fetch if phases belong to current treatment (prevent 403 from stale phase)
    if (patientPhasesTreatmentRef.current !== currentTreatmentId) {
      console.log('[DEBUG] Phases not loaded for current treatment yet. Phases belong to:', patientPhasesTreatmentRef.current, 'Current treatment:', currentTreatmentId);
      return;
    }
    
    // Only fetch if we have a valid phase AND phases are loaded for current treatment
    if (patientPhases && patientPhases.length > 0) {
      // Verify the selectedPhaseId exists in current patientPhases (avoid 403 from stale phase)
      const phaseExists = patientPhases.some(p => p.id === selectedPhaseId);
      if (phaseExists) {
        // console.log('[DEBUG] Fetching exercises for phase:', selectedPhaseId, 'treatment:', currentTreatmentId);
        fetchExercisesForPhase(selectedPhaseId).catch(() => {});
      } else {
        console.log('[DEBUG] selectedPhaseId', selectedPhaseId, 'not in current phases:', patientPhases.map(p => p.id).join(', '));
      }
    } else {
      console.log('[DEBUG] No phases loaded yet, skipping fetch');
    }
  }, [selectedPhaseId, selectedPatient?.treatment_id, patientPhaseIdsKey]); // fetchExercisesForPhase defined later, don't include in deps
  let didCancel = false;
  const classes = useStyles();
  const prevTokenRef = useRef(undefined);
  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  
  const dispatch = useDispatch();
  // Removed selectedProfile and selectedProfileId. Use only selectedPatient.
  const [searchInput, setSearchInput] = useState("");
  
  useEffect(() => {
    if (!isLoggedIn) {
      window.location.replace("/");
    }
  }, [isLoggedIn]);


  // Persistence keys
  const PERSIST_KEYS = {
    selectedPatient: 'vp_selectedPatientId',
    searchInput: 'vp_patientListSearch'
  };

  // Restore search input on mount
  useEffect(() => {
    try {
      const saved = localStorage.getItem(PERSIST_KEYS.searchInput);
      if (saved) setSearchInput(saved);
    } catch (e) {
      // ignore
    }
  }, []);

  // Persist search input
  useEffect(() => {
    try {
      if (searchInput) localStorage.setItem(PERSIST_KEYS.searchInput, searchInput);
      else localStorage.removeItem(PERSIST_KEYS.searchInput);
    } catch (e) {
      // ignore
    }
  }, [searchInput]);

  const restoreSelectedPatientFromProfile = useCallback((profile) => {
    if (!profile) return false;
    restoredPatientRef.current = true;
    handleSelectProfile(profile);
    return true;
  }, [handleSelectProfile]);

  // Restore selected patient when profiles are loaded (profiles fetched async)
  // Only restore once per userId to avoid infinite loops
  useEffect(() => {
    let cancelled = false;

    const restoreInitialPatient = async () => {
      try {
        if (!userId) {
          restoredPatientRef.current = false;
          return;
        }
        if (restoredPatientRef.current) return;
        if (!profiles || profiles.length === 0) return;

        const savedId = localStorage.getItem(`vp_selectedPatientId_${userId}`);
        if (savedId) {
          const found = profiles.find(p => String(p.user_id) === String(savedId) || String(p.id) === String(savedId));
          if (found) {
            restoreSelectedPatientFromProfile(found);
            return;
          }
        }

        if (!token) return;
        const response = await fetch(`${backendBaseUrl}/api/calendar/appointments/`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Accept': 'application/json'
          },
          method: 'GET',
        });
        if (!response.ok || cancelled || restoredPatientRef.current) return;

        const data = await response.json();
        if (cancelled || restoredPatientRef.current) return;

        const now = new Date();
        const upcomingAppointments = (Array.isArray(data.appointments) ? data.appointments : [])
          .filter(appointment => appointment && appointment.patient && new Date(appointment.end_datetime) >= now)
          .sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime));

        const nextUpcomingPatientId = upcomingAppointments.length ? upcomingAppointments[0].patient : null;
        if (!nextUpcomingPatientId) {
          const fallbackProfile = profiles.find((profile) => (
            Array.isArray(profile.diagnosis) && profile.diagnosis.length > 0
          )) || profiles[0];
          if (fallbackProfile) {
            restoreSelectedPatientFromProfile(fallbackProfile);
          } else {
            restoredPatientRef.current = true;
          }
          return;
        }

        const nextProfile = profiles.find(profile => (
          String(profile.user_id) === String(nextUpcomingPatientId)
          || String(profile.id) === String(nextUpcomingPatientId)
        ));
        if (nextProfile) {
          restoreSelectedPatientFromProfile(nextProfile);
          return;
        }

        restoredPatientRef.current = true;
      } catch (e) {
        // ignore
      }
    };

    restoreInitialPatient();
    return () => {
      cancelled = true;
    };
  }, [userId, profiles, token, restoreSelectedPatientFromProfile]);

  // Persist selected patient id
  useEffect(() => {
    try {
      if (!userId) return;
      const key = `vp_selectedPatientId_${userId}`;
      if (selectedPatient && (selectedPatient.user_id || selectedPatient.id)) {
        localStorage.setItem(key, String(selectedPatient.user_id || selectedPatient.id));
      }
    } catch (e) {
      // ignore
    }
  }, [selectedPatient, userId]);

  // Listen for cross-page patient selection changes (e.g. calendar → patient list)
  useEffect(() => {
    if (!userId || !profiles.length) return;
    const key = `vp_selectedPatientId_${userId}`;

    const handleStorageChange = (e) => {
      if (e.key !== key) return;
      const newId = e.newValue;
      if (!newId) return;
      // Skip if already selected
      const currentId = selectedPatient && (selectedPatient.user_id || selectedPatient.id);
      if (String(currentId) === String(newId)) return;
      const found = profiles.find(p => String(p.user_id) === String(newId) || String(p.id) === String(newId));
      if (found) {
        handleSelectProfile(found);
        return;
      }

      const refreshRoster = fetchUserTableDataRef.current;
      if (!refreshRoster) return;

      refreshRoster().then((refreshedProfiles) => {
        const refreshedFound = Array.isArray(refreshedProfiles)
          ? refreshedProfiles.find(p => String(p.user_id) === String(newId) || String(p.id) === String(newId))
          : null;
        if (refreshedFound) {
          handleSelectProfile(refreshedFound);
        }
      }).catch(() => {
        // ignore refresh failures for calendar sync
      });
    };

    const handleSameTabPatientChange = (event) => {
      const detail = event?.detail || {};
      if (detail.key !== key) return;
      handleStorageChange({ key: detail.key, newValue: detail.patientId });
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('vp:selectedPatientId', handleSameTabPatientChange);
    // Also check localStorage on focus (user switches back from calendar tab)
    const handleFocus = () => {
      try {
        const current = localStorage.getItem(key);
        if (current) handleStorageChange({ key, newValue: current });
      } catch (e) { /* ignore */ }
    };
    window.addEventListener('focus', handleFocus);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('vp:selectedPatientId', handleSameTabPatientChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [userId, profiles, selectedPatient, handleSelectProfile]);

  // Persist selectedPhaseId per-patient and restore when patient phases are available
  useEffect(() => {
    if (!selectedPatient) return;
    const key = `vp_selectedPhaseId_${selectedPatient.user_id || selectedPatient.id}`;
    try {
      const saved = localStorage.getItem(key);
      if (saved && patientPhases && patientPhases.length) {
        const ph = patientPhases.find(p => String(p.id) === String(saved));
        if (ph) setSelectedPhaseId(ph.id);
      }
    } catch (e) {
      // ignore
    }
  }, [selectedPatient, patientPhases]);

  useEffect(() => {
    if (!selectedPatient) return;
    const key = `vp_selectedPhaseId_${selectedPatient.user_id || selectedPatient.id}`;
    try {
      if (selectedPhaseId) localStorage.setItem(key, String(selectedPhaseId));
      else localStorage.removeItem(key);
    } catch (e) {
      // ignore
    }
  }, [selectedPhaseId, selectedPatient]);


  const handleGetJournalButtonClick = (user_id) => {
    console.log(typeof user_id)
    console.log(user_id)
    fetch(`${backendBaseUrl}/journal/selectedPatient/${user_id}`, {
        headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json",
        },
        method: "GET",
    })
    .then((response) => response.blob())
    .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "filename.pdf");
        document.body.appendChild(link);
        link.click();
    })
};
const [previewExercises, setPreviewExercises] = useState([]);
  
  // Dialog handlers received from container
  const { onOpenCreatePatientDialog, onOpenAddTreatmentDialog, onOpenEditTreatmentDialog, onDialogPatientCreated, onDialogTreatmentAdded, onRegisterAddTreatmentHandler, onRegisterEditTreatmentHandler, onRegisterDeleteTreatmentHandler, onRegisterArchiveTreatmentHandler, onRegisterReactivateTreatmentHandler } = props;
const handleAddExercise = (exercise) => {
  // Use a unique identifier, fallback to title if no id
  const uniqueId = exercise.id || exercise.identifier || exercise.title;
  if (previewExercises.some(e => (e.id || e.identifier || e.title) === uniqueId)) return;
  // Set default index
  const index = exercises.length + previewExercises.length + 1;
  setPreviewExercises(prev => [...prev, { ...exercise, index }]);
};

const handleRemovePreviewExercise = (exercise) => {
  const uniqueId = exercise.id || exercise.identifier || exercise.title;
  setPreviewExercises(prev => prev.filter(e => (e.id || e.identifier || e.title) !== uniqueId));
};

// Dialog open handlers passed from container - no local dialog state needed

//Fetches user data for each user in the database
const fetchUserTableData = useCallback(async () => {
  if (didCancel) return null;
  const response = await fetch(`${backendBaseUrl}/treatment/getUserTable/`, {
    headers: {
      "Authorization": `Token ${token}`
    },
    method: "GET",
  });
  if (response.ok) {
    const data = await response.json();
    patientRosterCache.set(token, { profiles: data, fetchedAt: Date.now() });
    setProfiles(data)

    const currentSelectedPatient = selectedPatientRef.current;
    if (currentSelectedPatient) {
      const selectedUserId = currentSelectedPatient.user_id || currentSelectedPatient.id || (currentSelectedPatient.user && currentSelectedPatient.user.id);
      const refreshedProfile = data.find(patient => {
        const patientUserId = patient.user_id || patient.id || (patient.user && patient.user.id);
        return String(patientUserId) === String(selectedUserId);
      });

      if (refreshedProfile) {
        const selectedTreatments = selectedTreatmentByUserRef.current || {};
        const refreshedDiagnoses = Array.isArray(refreshedProfile.diagnosis) ? refreshedProfile.diagnosis : [];
        const preferredTreatmentId = selectedTreatments[selectedUserId]
          || currentSelectedPatient.treatment_id
          || (currentSelectedPatient.treatment && currentSelectedPatient.treatment.id)
          || null;
        const matchedDiagnosis = preferredTreatmentId
          ? refreshedDiagnoses.find(diagnosis => String(diagnosis.treatment_id || diagnosis.id) === String(preferredTreatmentId))
          : null;
        const resolvedDiagnosis = matchedDiagnosis || (refreshedDiagnoses.length ? refreshedDiagnoses[refreshedDiagnoses.length - 1] : null);
        const resolvedTreatmentId = resolvedDiagnosis
          ? (resolvedDiagnosis.treatment_id || resolvedDiagnosis.id || null)
          : preferredTreatmentId;
        const resolvedDiagnosisId = resolvedDiagnosis
          ? (resolvedDiagnosis.diagnosis_id || resolvedDiagnosis.id || null)
          : (currentSelectedPatient.selected_diagnosis_id || null);
        const resolvedDiagnosisIdentifier = resolvedDiagnosis
          ? (resolvedDiagnosis.diagnosis_identifier || resolvedDiagnosis.identifier || null)
          : (currentSelectedPatient.selected_diagnosis_identifier || null);

        setSelectedPatient({
          ...refreshedProfile,
          treatment_id: resolvedTreatmentId,
          selected_diagnosis_id: resolvedDiagnosisId,
          selected_diagnosis_identifier: resolvedDiagnosisIdentifier,
          treatment: { ...(refreshedProfile.treatment || {}), id: resolvedTreatmentId }
        });
        setSelectedDiagnosisId(resolvedDiagnosisIdentifier || null);
      }
    }

    setIsLoading(false)
    return data; // Return the fetched data
  } else {
    alert("ERROR")
    setIsLoading(false)
    return null;
  }
}, [token]);

fetchUserTableDataRef.current = fetchUserTableData;

// Triggered from DiagnosisCell to open dialog for adding a new treatment
const handleNewTreatmentRequested = useCallback((profile) => {
  if (!profile || !profile.user_id) return;
  if (onOpenAddTreatmentDialog) {
    onOpenAddTreatmentDialog(profile);
  }
}, [onOpenAddTreatmentDialog]);

const handleEditTreatmentRequested = useCallback((profile, treatment) => {
  if (!profile || !profile.user_id || !treatment) return;
  if (onOpenEditTreatmentDialog) {
    onOpenEditTreatmentDialog(profile, treatment);
  }
}, [onOpenEditTreatmentDialog]);

const handleDeleteTreatmentRequested = useCallback(async (profile, treatment) => {
  if (!profile || !profile.user_id || !treatment || !treatment.id) return;

  const treatmentName = treatment.name || treatment.diagnosis?.diagnosis || 'this treatment';
  if (!window.confirm(`Delete ${treatmentName}? This cannot be undone.`)) return;

  const response = await fetch(`${backendBaseUrl}/treatment/treatments/${treatment.id}/`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Token ${token}`,
    },
  });

  if (!response.ok) {
    let errorMessage = 'Failed to delete treatment';
    try {
      const errorData = await response.json();
      errorMessage = errorData.error || errorData.detail || errorMessage;
    } catch (error) {
      // Keep the generic message when the API response has no JSON body.
    }
    throw new Error(errorMessage);
  }

  setSelectedTreatmentByUser(previous => {
    const updated = { ...previous };
    delete updated[profile.user_id];
    return updated;
  });
  await fetchUserTableData();
}, [token, fetchUserTableData]);

useEffect(() => {
  if (typeof onRegisterDeleteTreatmentHandler === 'function') {
    onRegisterDeleteTreatmentHandler(handleDeleteTreatmentRequested);
  }
}, [handleDeleteTreatmentRequested, onRegisterDeleteTreatmentHandler]);

const handleArchiveTreatmentRequested = useCallback(async (profile, treatment) => {
  if (!profile || !treatment?.id) return;
  const response = await fetch(`${backendBaseUrl}/treatment/treatments/${treatment.id}/archive/`, {
    method: 'PATCH',
    headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ archived: true }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to archive treatment');
  }
  setSelectedTreatmentByUser(previous => {
    const updated = { ...previous };
    delete updated[profile.user_id];
    return updated;
  });
  await fetchUserTableData();
}, [token, fetchUserTableData]);

const handleReactivateTreatmentRequested = useCallback(async (profile, treatment) => {
  if (!profile || !treatment?.id) return;
  const response = await fetch(`${backendBaseUrl}/treatment/treatments/${treatment.id}/archive/`, {
    method: 'PATCH',
    headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ archived: false }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to reactivate treatment');
  }
  await fetchUserTableData();
}, [token, fetchUserTableData]);

useEffect(() => {
  if (typeof onRegisterArchiveTreatmentHandler === 'function') {
    onRegisterArchiveTreatmentHandler(handleArchiveTreatmentRequested);
  }
}, [handleArchiveTreatmentRequested, onRegisterArchiveTreatmentHandler]);

useEffect(() => {
  if (typeof onRegisterReactivateTreatmentHandler === 'function') {
    onRegisterReactivateTreatmentHandler(handleReactivateTreatmentRequested);
  }
}, [handleReactivateTreatmentRequested, onRegisterReactivateTreatmentHandler]);

// Handle submission of new treatment from dialog
const handleAddTreatmentSubmit = useCallback(async ({ treatmentName, diagnosisIdentifier, autoGenerate, complaintArea, patient, sendFullAssessment, sendShortAssessment, patientEmail }) => {
  const isShortForm = sendShortAssessment && !sendFullAssessment;
  console.log('[handleAddTreatmentSubmit] Creating treatment:', { treatmentName, diagnosisIdentifier, autoGenerate, sendFullAssessment, sendShortAssessment, isShortForm });
  
  try {
    // Step 1: Create treatment via backend endpoint
    const createResponse = await fetch(`${backendBaseUrl}/treatment/create/`, {
      method: 'POST',
      headers: {
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        patient_id: patient.user_id,
        treatment_name: treatmentName,
        diagnosis_identifier: diagnosisIdentifier,
        auto_generate: autoGenerate,
        complaint_area: complaintArea,
      })
    });

    if (!createResponse.ok) {
      const errorData = await createResponse.json();
      throw new Error(errorData.error || 'Failed to create treatment');
    }

    const createData = await createResponse.json();
    console.log('[handleAddTreatmentSubmit] Treatment created:', createData);
    
    // Extract treatment_id from response to scope assessment to this treatment
    const treatmentId = createData.treatment_id || createData.id;
    if (!treatmentId) {
      console.warn('[handleAddTreatmentSubmit] No treatment_id in response:', createData);
    }

    // Step 2: Generate assessment link for the new treatment (use is_short_form based on selection)
    const linkResult = await generateAssessmentLink(patient.user_id, diagnosisIdentifier, true, isShortForm, treatmentId);
    console.log('[handleAddTreatmentSubmit] Assessment link generated:', linkResult);

    // Step 3: Send email if patient email provided
    if (patientEmail) {
      console.log('[handleAddTreatmentSubmit] Sending assessment link to email:', patientEmail);
      const emailResponse = await fetch(`${backendBaseUrl}/user/send_assessment_link/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          patient_email: patientEmail,
          treatment_name: treatmentName,
          assessment_url: linkResult.url,
          patient_name: `${patient.first_name} ${patient.last_name}`
        })
      });

      if (!emailResponse.ok) {
        const emailError = await emailResponse.json();
        console.warn('[handleAddTreatmentSubmit] Email sending failed but treatment was created:', emailError);
        // Don't throw - email failure shouldn't stop treatment creation
      } else {
        console.log('[handleAddTreatmentSubmit] Email sent successfully');
      }
    } else {
      // Step 3b: Open assessment link in new tab if no email provided
      const fullUrl = `${window.location.origin}${linkResult.url}`;
      window.open(fullUrl, '_blank');
    }

    // Step 4: Add the new treatment locally; fetching the entire clinic roster is unnecessary.
    if (treatmentId) {
      const resolvedDiagUuid = createData.diagnosis_id || null;
      const resolvedDiagIdentifier = createData.diagnosis_identifier || diagnosisIdentifier || null;
      const newDiagnosis = {
        treatment_id: treatmentId,
        diagnosis_id: resolvedDiagUuid,
        diagnosis_identifier: resolvedDiagIdentifier,
        title: createData.diagnosis || resolvedDiagIdentifier || 'Unknown Diagnosis',
        treatment_name: createData.treatment_name || treatmentName,
        primary_complaint_key: createData.primary_complaint_key || '',
        primary_complaint_label: createData.primary_complaint_label || '',
        exercise_library_region: createData.exercise_library_region || '',
      };
      const isTargetPatient = (profile) => String(profile?.user_id || profile?.id || '') === String(patient.user_id);
      const addTreatmentToProfile = (profile) => {
        if (!isTargetPatient(profile)) return profile;
        const diagnoses = Array.isArray(profile.diagnosis) ? profile.diagnosis : [];
        const existingIndex = diagnoses.findIndex((item) => String(item.treatment_id || item.id || '') === String(treatmentId));
        const updatedDiagnoses = existingIndex === -1
          ? [...diagnoses, newDiagnosis]
          : diagnoses.map((item, index) => (index === existingIndex ? { ...item, ...newDiagnosis } : item));
        return { ...profile, diagnosis: updatedDiagnoses };
      };
      const currentPatient = selectedPatientRef.current;
      const updatedPatient = isTargetPatient(currentPatient)
        ? addTreatmentToProfile(currentPatient)
        : addTreatmentToProfile(patient);

      setProfiles((currentProfiles) => currentProfiles.map(addTreatmentToProfile));

      // Mark this treatment as user-selected so the dropdown reflects it
      setSelectedTreatmentByUser(prev => ({ ...prev, [patient.user_id]: treatmentId }));
      setSelectedDiagnosisId(resolvedDiagIdentifier || null);

      // Clear stale phase/exercise state and select the new treatment immediately
      setSelectedPatientData(null);
      setSelectedPhaseId('');
      setPatientPhases([]);
      setExercises([]);
      setPatientMetrics({});
      patientPhasesTreatmentRef.current = null;
      userSelectedPhaseRef.current = false;
      lastFetchParamsRef.current = null;

      setSelectedPatient({
        ...updatedPatient,
        treatment_id: treatmentId,
        selected_diagnosis_id: resolvedDiagUuid,
        selected_diagnosis_identifier: resolvedDiagIdentifier || null,
        treatment: { ...(updatedPatient.treatment || {}), id: treatmentId },
        exercise_library_region: createData.exercise_library_region || '',
      });

      // Pull consolidated data for the new treatment so UI updates immediately
      if (typeof fetchPatientAllData === 'function') {
        await fetchPatientAllData(patient.user_id, resolvedDiagUuid || null, treatmentId);
      }
    }
    
    console.log('[handleAddTreatmentSubmit] Treatment added successfully');
  } catch (err) {
    console.error('[handleAddTreatmentSubmit] Error:', err);
    throw err; // Re-throw to let dialog show error
  }
}, [backendBaseUrl, token, generateAssessmentLink, fetchPatientAllData]);

const handleEditTreatmentSubmit = useCallback(async ({ treatmentName, complaintArea, treatment }) => {
  if (!treatment || !treatment.id) {
    throw new Error('Missing treatment to update');
  }
  if (!treatmentName || !treatmentName.trim()) {
    throw new Error('Please enter a treatment name');
  }

  const response = await fetch(`${backendBaseUrl}/treatment/treatments/${treatment.id}/settings/`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Token ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name: treatmentName.trim(),
      complaint_area: complaintArea,
    })
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to update treatment');
  }

  const updatedTreatment = await response.json();
  const patientId = selectedPatient?.user_id || selectedPatient?.id || treatment.user_id;
  const applyTreatmentUpdate = (profile) => {
    if (!profile || String(profile.user_id || profile.id || '') !== String(patientId || '')) return profile;
    return {
      ...profile,
      diagnosis: (profile.diagnosis || []).map((item) => (
        String(item.treatment_id || item.id || '') === String(treatment.id)
          ? {
            ...item,
            treatment_name: updatedTreatment.name || treatmentName.trim(),
            primary_complaint_key: updatedTreatment.primary_complaint_key || '',
            primary_complaint_label: updatedTreatment.primary_complaint_label || '',
            exercise_library_region: updatedTreatment.exercise_library_region || '',
          }
          : item
      )),
    };
  };

  setProfiles((currentProfiles) => currentProfiles.map(applyTreatmentUpdate));
  setSelectedPatient((currentPatient) => {
    const updatedPatient = applyTreatmentUpdate(currentPatient);
    if (!updatedPatient || String(updatedPatient.treatment_id || '') !== String(treatment.id)) return updatedPatient;
    return {
      ...updatedPatient,
      exercise_library_region: updatedTreatment.exercise_library_region || '',
    };
  });
}, [backendBaseUrl, selectedPatient?.id, selectedPatient?.user_id, token]);

useEffect(() => {
  if (typeof onRegisterAddTreatmentHandler === 'function') {
    onRegisterAddTreatmentHandler(handleAddTreatmentSubmit);
  }
}, [handleAddTreatmentSubmit, onRegisterAddTreatmentHandler]);

useEffect(() => {
  if (typeof onRegisterEditTreatmentHandler === 'function') {
    onRegisterEditTreatmentHandler(handleEditTreatmentSubmit);
  }
}, [handleEditTreatmentSubmit, onRegisterEditTreatmentHandler]);

const handleProfileSaved = useCallback((updatedData) => {
  setSelectedPatient(prev => prev ? { ...prev, ...updatedData } : prev);
  setProfiles(prev => prev.map(p =>
    p.user_id === selectedPatient?.user_id ? { ...p, ...updatedData } : p
  ));
}, [selectedPatient?.user_id]);

const handlePatientCreated = useCallback(async (data) => {
  // Refresh patient list and get updated profiles
  const updatedProfiles = await fetchUserTableData();
  
  // Find and select the newly created patient from the refreshed list
  if (updatedProfiles && data.user_id) {
    const newPatient = updatedProfiles.find(p => p.user_id === data.user_id);
    if (newPatient) {
      // Force Overview tab for new patient
      try {
        localStorage.setItem('vp_activeTab', 'Overview');
      } catch (e) {}
      handleSelectProfile(newPatient);
    }
  }
  
  // Notify container to close dialog
  if (onDialogPatientCreated) {
    onDialogPatientCreated(data);
  }
}, [handleSelectProfile, fetchUserTableData, onDialogPatientCreated]);

useEffect(() => {
  // Re-run data load when auth `token` changes. Only clear persisted data when
  // switching from one token to another or when logging out — not on initial mount
  setIsLoading(true);
  const prev = prevTokenRef.current;
  const isInitialMount = (prev === undefined);

  // If this is not the initial mount and the token changed, clear caches
  if (!isInitialMount && prev !== token) {
    // clear in-memory caches/state for the new auth context
    setProfiles([]);
    setSelectedPatient(null);
    setPatientPhases([]);
    setExercises([]);
    setPatientMetrics({});
    setLibraryExercises([]);

    // If this change represents a logout (previous token existed, now none),
    // remove persisted keys for the previous user to avoid leaving stale data.
    if (prev && !token) {
      try {
        const prevUserId = prevUserIdRef.current;
        if (prevUserId) {
          localStorage.removeItem(`vp_patientMetrics_${prevUserId}`);
          localStorage.removeItem(`vp_patientScores_${prevUserId}`);
          localStorage.removeItem(`vp_selectedPatientId_${prevUserId}`);
        }
      } catch (e) {
        // ignore
      }
    }
  }

  const cachedRoster = getCachedPatientRoster(token);
  if (cachedRoster) {
    setProfiles(cachedRoster);
    setIsLoading(false);
  } else if (token) {
    fetchUserTableData();
  }
  let didCancel = false;
  prevTokenRef.current = token;
  prevUserIdRef.current = userId;
  return () => {
    didCancel = true;
  };
}, [token, fetchUserTableData, userId]);

// Fetch exercise library once and share with children to avoid duplicate network calls
useEffect(() => {
  let cancelled = false;
  if (!token) return;
  const fetchLibrary = async () => {
    try {
      const res = await fetch(`${backendBaseUrl}/treatment/exercise/`, {
        headers: { Authorization: `Token ${token}` },
        method: 'GET'
      });
      if (!res.ok) {
        console.error('Failed to fetch exercise library', res.status);
        return;
      }
      const data = await res.json();
      if (!cancelled) {
        setLibraryExercises(data.exercises || []);
        setLibraryLoaded(true);
      }
    } catch (err) {
      if (!cancelled) console.error('fetchLibrary error', err);
    }
  };
  fetchLibrary();
  return () => { cancelled = true; };
}, [token]);

// Listen for diagnosis changes to refresh patient data
useEffect(() => {
  const onDiagnosisChanged = async (event) => {
    try {
      const { userId, diagnosisId } = event.detail || {};
      console.log('Diagnosis changed event received for userId:', userId);
      
      // If the changed patient is currently selected, refresh their data
      if (selectedPatient && selectedPatient.user_id === userId) {
        // Clear stale consolidated data so it doesn't overwrite refreshed data
        setSelectedPatientData(null);
        patientPhasesTreatmentRef.current = null;
        setSelectedPhaseId('');
        userSelectedPhaseRef.current = false;
        
        // CRITICAL: Refetch patient profile FIRST to get updated treatment_id
        await fetchUserTableData();
        
        // Wait for profiles to update, then get the refreshed patient with new treatment_id
        await new Promise(resolve => setTimeout(resolve, 300));
        
        // Find the updated patient with fresh treatment_id
        let updatedPatient = null;
        setProfiles(prev => {
          updatedPatient = prev.find(p => (p.user_id || p.id) === userId);
          if (updatedPatient) {
            if (updatedPatient.diagnosis && updatedPatient.diagnosis.length > 0) {
              setDiagnosis(updatedPatient.diagnosis);
            }
          }
          return prev;
        });
        
        if (!updatedPatient) {
          console.warn('[onDiagnosisChanged] Could not find updated patient in profiles');
          return;
        }
        
        // Extract fresh treatment_id from updated patient
        const freshTreatmentId = updatedPatient.treatment_id || 
          (updatedPatient.diagnosis && updatedPatient.diagnosis.length > 0 
            ? updatedPatient.diagnosis[updatedPatient.diagnosis.length - 1]?.treatment_id 
            : null);
        
        console.log('[onDiagnosisChanged] Using fresh treatment_id:', freshTreatmentId);
        
                // CRITICAL: Update selectedPatient with fresh treatment_id BEFORE calling fetchPatientAllData
                // This ensures fetchExercisesForPhase sees the correct treatment_id
                setSelectedPatient(prev => ({
                  ...updatedPatient,
                  treatment_id: freshTreatmentId,
                  selected_diagnosis_id: diagnosisId || updatedPatient.selected_diagnosis_id,
                }));
        
                // Wait a tick for selectedPatient state to update
                await new Promise(resolve => setTimeout(resolve, 50));
        
        // Now fetch consolidated data with fresh treatment_id
        if (typeof fetchPatientAllData === 'function') {
          await fetchPatientAllData(userId, diagnosisId || null, freshTreatmentId);
        }
        
        // Refetch phases with fresh treatment_id
        const phasesParams = new URLSearchParams();
        if (freshTreatmentId) {
          phasesParams.append('treatment_id', freshTreatmentId);
        }
        const phasesUrl = `${backendBaseUrl}/treatment/phases/patient/${userId}/?${phasesParams.toString()}`;
        console.log('[onDiagnosisChanged] Fetching phases from:', phasesUrl);
        const phasesRes = await fetch(phasesUrl, {
          headers: { "Authorization": `Token ${token}`, Accept: 'application/json' }
        });
        if (phasesRes.ok) {
          const phasesData = await phasesRes.json();
          const nextPhases = phasesData.phases || [];
          console.log('[onDiagnosisChanged] Response phases:', nextPhases.map(p => ({id: p.id, name: p.name})));
          setPatientPhases(nextPhases);
          patientPhasesTreatmentRef.current = freshTreatmentId;

          // Auto-select first phase from refreshed list
          if (nextPhases.length > 0) {
            const firstPhaseId = nextPhases[0].id;
            setSelectedPhaseId(firstPhaseId);
            
          }
        }
      }
    } catch (err) {
      console.warn('Failed to refresh after diagnosis change:', err);
    }
  };
  
  window.addEventListener('diagnosisChanged', onDiagnosisChanged);

  // When a journal with new baselines is saved, bust the KPI metrics cache for that patient
  const onKpiBaselinesUpdated = (event) => {
    try {
      const { user_id, treatment_id } = (event && event.detail) || {};
      if (!user_id) return;
      const keysToDelete = new Set();
      if (treatment_id) keysToDelete.add(`${user_id}_${treatment_id}`);
      setPatientMetrics(prev => {
        const next = { ...prev };
        Object.keys(next).forEach(key => {
          if (keysToDelete.has(key) || key.startsWith(`${user_id}_`)) delete next[key];
        });
        return next;
      });
      // Also clear merged metrics from the row and selected patient so the refetch path runs.
      setProfiles(prev => prev.map(r => {
        const rid = r.user_id || r.id || (r.user && r.user.id);
        return rid === user_id ? { ...r, _metrics: undefined } : r;
      }));
      setSelectedPatient(prev => {
        if (!prev) return prev;
        const rid = prev.user_id || prev.id || (prev.user && prev.user.id);
        return rid === user_id ? { ...prev, _metrics: undefined } : prev;
      });

      // Trigger an immediate refetch + re-merge so PatientTable updates without
      // requiring a manual page refresh. Resolve the row's diagnosis and
      // (preferred) treatment_id from the freshest profiles snapshot via a
      // functional setter, then kick off the network call asynchronously.
      setProfiles(prev => {
        try {
          const row = prev.find(r => {
            const rid = r.user_id || r.id || (r.user && r.user.id);
            return rid === user_id;
          });
          if (row) {
            const tid = treatment_id
              || selectedTreatmentByUser[user_id]
              || (row.diagnosis && row.diagnosis.length
                ? (row.diagnosis[row.diagnosis.length - 1].treatment_id
                  || row.diagnosis[row.diagnosis.length - 1].id)
                : null);
            const diagId = getDiagnosisForTreatment(row, tid)?.diagnosis_identifier
              || getDiagnosisForTreatment(row, tid)?.identifier
              || row.diagnosisIdentifier
              || null;
            if (diagId) {
              const cacheKey = `${user_id}_${tid || diagId}`;
              fetchPatientMetrics(user_id, diagId, tid, { force: true }).then(metrics => {
                if (!metrics) return;
                const funcImp = extractFunctionFromImprovements(metrics.improvements);
                const funcBase = extractFunctionFromBaseline(metrics.baseline);
                const merged = {
                  baseline_text: (funcImp && funcImp.baseline_text) || (funcBase && funcBase.baseline_text) || null,
                  latest_function: (funcImp && funcImp.followup_value !== null && funcImp.followup_value !== undefined)
                    ? funcImp.followup_value
                    : (funcBase && funcBase.numeric_value !== null ? funcBase.numeric_value : null),
                  function_percent: funcImp && funcImp.percent_change !== null && funcImp.percent_change !== undefined
                    ? funcImp.percent_change
                    : null,
                  baseline_payload: metrics.baseline,
                  improvements_payload: metrics.improvements,
                  kpi_items: metrics.kpiItems || [],
                  fetchedAt: metrics.fetchedAt || null,
                  _cacheKey: cacheKey,
                };
                setProfiles(p2 => p2.map(r => (
                  ((r.user_id || r.id || (r.user && r.user.id)) === user_id)
                    ? { ...r, _metrics: merged }
                    : r
                )));
                setSelectedPatient(sp => {
                  if (!sp) return sp;
                  const rid = sp.user_id || sp.id || (sp.user && sp.user.id);
                  return rid === user_id ? { ...sp, _metrics: merged } : sp;
                });
              }).catch(() => {});
            }
          }
        } catch (err) {
          console.warn('[kpiBaselinesUpdated] refetch error', err);
        }
        return prev;
      });
    } catch (e) {
      console.warn('[kpiBaselinesUpdated] handler error', e);
    }
  };
  window.addEventListener('kpiBaselinesUpdated', onKpiBaselinesUpdated);

  // Clinician follow-up dialog (DevelopmentView) emits this event after a
  // successful save so the patient row's Function/Pain headlines and any
  // open metrics panels refresh with the new follow-up data point — same
  // refresh path as a baseline edit.
  const onKpiUpdated = (e) => {
    try {
      const detail = (e && e.detail) || {};
      const uid = detail.patient_id;
      if (!uid) return;
      // Reuse the kpiBaselinesUpdated handler so we don't duplicate the
      // metrics-merge logic.
      window.dispatchEvent(new CustomEvent('kpiBaselinesUpdated', {
        detail: { user_id: uid, treatment_id: detail.treatment_id },
      }));
    } catch (_) { /* no-op */ }
  };
  window.addEventListener('virtus:kpi-updated', onKpiUpdated);

  return () => {
    window.removeEventListener('diagnosisChanged', onDiagnosisChanged);
    window.removeEventListener('kpiBaselinesUpdated', onKpiBaselinesUpdated);
    window.removeEventListener('virtus:kpi-updated', onKpiUpdated);
  };
}, [token, selectedPatient, selectedPhaseId, fetchUserTableData, fetchPatientAllData]);

// Fetch all phases for the selected patient (using new endpoint with correct phase IDs)
const fetchPhasesForPatient = async (selectedPatient) => {
  if (!selectedPatient || !selectedPatient.user_id) {
    setPatientPhases([]);
    return;
  }
  const phasesParams = new URLSearchParams();
  if (selectedPatient.treatment_id) {
    phasesParams.append('treatment_id', selectedPatient.treatment_id);
  }
  const phasesUrl = `${backendBaseUrl}/treatment/phases/patient/${selectedPatient.user_id}/?${phasesParams.toString()}`;
  console.log('[fetchPhasesForPatient] Fetching from URL:', phasesUrl);
  fetch(phasesUrl, {
    headers: {
      "Authorization": `Token ${token}`,
      Accept: 'application/json'
    }
  })
    .then(response => response.ok ? response.json() : Promise.reject("Failed to fetch phases"))
    .then(data => {
      console.log('[fetchPhasesForPatient] Response phases:', data.phases ? data.phases.map(p => ({id: p.id, name: p.name})) : []);
      setPatientPhases(data.phases || []);
    })
    .catch(error => {
      setPatientPhases([]);
    });
};



  useEffect(() => {
    // Only set selectedPhaseId if it is not already set (undefined or empty string)
    if (!selectedPatient || !selectedPatient.user_id) {
      setSelectedPhaseId('');
      return;
    }
    if (!patientPhases || patientPhases.length === 0) {
      setSelectedPhaseId('');
      return;
    }
    if (!selectedPhaseId) {
      let currentPhaseId = '';
      if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
        const activeDiagnosis = selectedPatient.diagnosis[selectedPatient.diagnosis.length - 1];
        if (activeDiagnosis && activeDiagnosis.phase_id) {
          currentPhaseId = activeDiagnosis.phase_id;
        } else if (activeDiagnosis && activeDiagnosis.current_phase_id) {
          currentPhaseId = activeDiagnosis.current_phase_id;
        }
      }
      // Do NOT fallback to first phase if no currentPhaseId
      // Only set if currentPhaseId is found
      if (currentPhaseId) {
        setSelectedPhaseId(currentPhaseId);
      }
    }
  }, [selectedPatient, patientPhases]);

// Fetch exercises for a specific phase (by phase id)
const fetchExercisesForPhase = useCallback(async (phaseId, { force = false } = {}) => {
  if (!selectedPatient || !patientPhases.length) return;
  // Only allow valid phaseId
  const phaseObj = patientPhases.find(p => p.id === phaseId);
  if (!phaseObj) {
    // Silently skip - likely during patient transition; phase reset effect will handle resetting selectedPhaseId
    console.debug('[patientList] Phase not found, skipping fetch:', phaseId);
    return;
  }
  const userId = selectedPatient.user_id;
  // Include treatment_id OR diagnosis_id in query params for treatment-scoped fetching
  const params = new URLSearchParams();
  if (selectedPatient.treatment_id) {
    params.append('treatment_id', selectedPatient.treatment_id);
  } else if (selectedPatient.selected_diagnosis_id) {
    // Fallback: use diagnosis_id if treatment_id not available
    params.append('diagnosis_id', selectedPatient.selected_diagnosis_id);
  }
  const queryStr = params.toString() ? `?${params.toString()}` : '';
  const url = `${backendBaseUrl}/treatment/exercises/phase/${phaseId}/${userId}/${queryStr}`;
  const requestKey = `${userId}:${selectedPatient.treatment_id || selectedPatient.selected_diagnosis_id || ''}:${phaseId}`;
  const cached = exerciseCacheRef.current.get(requestKey);
  if (!force && cached && Date.now() - cached.fetchedAt < 5 * 60 * 1000) {
    setExercises(cached.exercises);
    return cached.exercises;
  }
  const existingRequest = exerciseFetchRef.current.inFlight.get(requestKey);
  if (existingRequest) {
    return existingRequest;
  }

  const requestId = exerciseFetchRef.current.requestId + 1;
  exerciseFetchRef.current.requestId = requestId;
  // console.log('[fetchExercisesForPhase] Fetching from:', url, { treatment_id: selectedPatient.treatment_id, diagnosis_id: selectedPatient.selected_diagnosis_id });
  const request = fetch(url, {
    headers: {
      "Authorization": `Token ${token}`,
      Accept: 'application/json'
    }
  })
    .then(response => response.ok ? response.json() : Promise.reject("Failed to fetch phase exercises"))
    .then(data => {
      const nextExercises = data.exercises || [];
      exerciseCacheRef.current.set(requestKey, { exercises: nextExercises, fetchedAt: Date.now() });
      if (exerciseFetchRef.current.requestId === requestId) {
        setExercises(nextExercises);
      }
      return nextExercises;
    })
    .catch(error => {
      console.error('[fetchExercisesForPhase] Error:', error);
      if (exerciseFetchRef.current.requestId === requestId) {
        setExercises([]);
      }
      throw error;
    })
    .finally(() => {
      exerciseFetchRef.current.inFlight.delete(requestKey);
    });
  exerciseFetchRef.current.inFlight.set(requestKey, request);
  return request;
}, [selectedPatient, patientPhases, token]);

useEffect(() => {
  const invalidateProgramPhaseCache = (event) => {
    const update = event?.detail;
    if (!update?.phaseId || !selectedPatient?.user_id) return;
    if (String(update.userId || '') !== String(selectedPatient.user_id)) return;
    if (String(update.treatmentId || '') !== String(selectedPatient.treatment_id || '')) return;
    const key = `${selectedPatient.user_id}:${selectedPatient.treatment_id}:${update.phaseId}`;
    exerciseCacheRef.current.delete(key);
  };

  window.addEventListener('vp-program-updated', invalidateProgramPhaseCache);
  return () => window.removeEventListener('vp-program-updated', invalidateProgramPhaseCache);
}, [selectedPatient?.user_id, selectedPatient?.treatment_id]);

// Parent helper: refresh exercises for the selected patient. Child can call this
// after saving to make the parent re-fetch and update `exercises` state.
const fetchExercisesForPatient = useCallback(async () => {
  if (!selectedPatient || !selectedPatient.user_id) {
    setExercises([]);
    return;
  }
  // Prefer explicit selected phase
  if (selectedPhaseId) {
    await fetchExercisesForPhase(selectedPhaseId);
    return;
  }
  // Fallback: use first patientPhase if available
  const fallbackPhase = (patientPhases && patientPhases.length) ? patientPhases[0].id : null;
  if (fallbackPhase) {
    await fetchExercisesForPhase(fallbackPhase);
    return;
  }
  // Nothing to fetch
  setExercises([]);
}, [selectedPatient, selectedPhaseId, patientPhases, fetchExercisesForPhase]);


const getCurrentPhase = () => {
  if (!selectedPatient || !selectedPatient.diagnosis || selectedPatient.diagnosis.length === 0) return null;
  // Get the phase with the highest progress
  const phase = selectedPatient.diagnosis.reduce((max, phase) => (phase.progress > (max?.progress || 0) ? phase : max), null);
  if (phase) {
    // Try to find the matching phase in patientPhases to get the index
    const matchingPhase = patientPhases.find(p => p.name === phase.name);
    const result = {
      progress: phase.progress,
      name: phase.name,
      index: matchingPhase ? matchingPhase.index : undefined
    };
    console.log('[PatientList] currentPhase (progress, name, index):', result);
    return result;
  }
  return null;
};


useEffect(() => {
  if (selectedPatient && selectedPatient.diagnosis) {
    // console.log('Selected patient diagnosis:', selectedPatient.diagnosis);
    // console.log('Patient phases:', patientPhases);
    // Try to log phase index for each diagnosis
    selectedPatient.diagnosis.forEach((phase) => {
      const matchingPhase = patientPhases.find(p => p.id === phase.id);
      // console.log('Diagnosis phase:', phase, 'Matching patientPhase:', matchingPhase);
      if (matchingPhase) {
        console.log('Phase index:', matchingPhase.index);
      }
    });
  }
}, [selectedPatient, patientPhases]);

  // PatientTable is now a separate memoized component - no longer define PatientSearchbar here

  const selectedPatientTreatmentContextId = selectedPatient
    ? (selectedPatient.treatment_id
      || (selectedPatient.user_id && selectedTreatmentByUser[selectedPatient.user_id])
      || (selectedPatient.id && selectedTreatmentByUser[selectedPatient.id])
      || '')
    : '';

return (
  <>
    <PatientTable 
      profiles={profiles} 
      selectedPatient={selectedPatient} 
      searchInput={searchInput}
      setSearchInput={setSearchInput}
      selectedTreatmentByUser={selectedTreatmentByUser}
      patientPhases={patientPhases}
      deriveTreatmentsFromProfile={deriveTreatmentsFromProfile}
      handleSelectProfile={handleSelectProfile} 
      handleTreatmentSelect={handleTreatmentSelect}
      handleNewTreatmentRequested={handleNewTreatmentRequested}
      handleEditTreatmentRequested={handleEditTreatmentRequested}
      onOpenCreatePatientDialog={onOpenCreatePatientDialog}
      classes={classes}
    />
    <Paper style={{marginTop: "0.5%", background: 'transparent', boxShadow: 'none'}}>
      <Grid container spacing={0} maxWidth="100%" className={classes.container2}>
        <Grid item xs={12} md={12} lg={12} style={{marginTop: 0, padding: 0}}>
          <SelectedPatientProgram 
            selectedPatient={selectedPatient}
            selectedPatientId={selectedPatient ? selectedPatient.user_id : ''}
            selectedPatientName={selectedPatient && selectedPatient.first_name && selectedPatient.last_name ? `${selectedPatient.first_name} ${selectedPatient.last_name}` : ''}
            profiles={profiles}
            allProfiles={profiles}
            diagnosis={selectedPatientData?.diagnosis}
            phases={(selectedPatientData?._treatmentId && selectedPatientData._treatmentId === selectedPatient?.treatment_id)
              ? selectedPatientData?.phases?.phases
              : []}
            advices={(selectedPatientData?._treatmentId && selectedPatientData._treatmentId === selectedPatient?.treatment_id)
              ? selectedPatientData?.advices
              : null}
            allDiagnoses={selectedPatientData?.allDiagnoses}
            sessionData={selectedPatientData?.session}
            assessmentDate={selectedPatientData?.assessmentDate}
            selectedPatientDataLoading={selectedPatientDataLoading}
            treatmentId={selectedPatient?.treatment_id}
            selectedTreatmentId={selectedPatientTreatmentContextId}
            token={token}
            exercises={exercises}
            libraryExercises={libraryExercises}
            libraryExercisesLoaded={libraryLoaded}
            fetchExercisesForPatient={fetchExercisesForPatient}
            fetchExercisesForPhase={fetchExercisesForPhase}
            fetchPatientAllData={fetchPatientAllData}
            refreshPatientTableData={fetchUserTableData}
            onProfileSaved={handleProfileSaved}
            selectedPhaseId={selectedPhaseId}
            setSelectedPhaseId={handleChildSetSelectedPhaseId}
          />
        </Grid>
      </Grid>
    </Paper>
    
    {/* Dialogs are now managed by PatientListContainer */}
  </>
);
}
